<script>
  // let category = new Map();
  // let business;
  let bannerBusiness = [];
  // let banners = new Map();
  let banners = [];
  let hidden = false;
  import { onMount } from "svelte";

  function getBusinessBanners() {
    var url = "https://cryptominder.biz/api/banners/banners.php";

    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        console.log(data);
        bannerBusiness = data;
      });
  }

  onMount(async () => {
    console.log("Hello from svelte!");
    getBusinessBanners();
    // getAllCategory();
    // let b = JSON.parse(localStorage.getItem("business"));
    // let c = JSON.parse(localStorage.getItem("category"));
    // if(c && c.length >0){

    // }
    // if (b && b.length > 0) {
    //     let bDate = localStorage.getItem("business-date");
    //     if(bDate && bDate >= Date.now()-86400 ){
    //         business = b;
    //         getBanners();
    //     }else{
    //         getBusiness();
    //     }
    // } else {
    //     getBusiness();
    // }
    setInterval(function () {
      checkPath();
    }, 1500);
  });
//   function getAllCategory() {
//     fetch("https://eosmarketplace.io/api/business_cat")
//       .then((response) => response.json())
//       .then((data) => {
//         // console.log(data);
//         data.result.forEach((x) => category.set(x._id, x.titles.en));

//         // category = data.result;
//       });
//   }
//   function getCategory(catid) {
//     return category.get(catid);
//   }
  function checkPath() {
    if (window.location.pathname != "/") {
      hidden = true;
    } else {
      hidden = false;
    }
  }

//   function getBusiness() {
//     let url = "https://eosmarketplace.io/api/business";
//     let xhr = new XMLHttpRequest();
//     xhr.open("GET", url);
//     xhr.onreadystatechange = function () {
//       if (xhr.readyState === 4) {
//         business = JSON.parse(xhr.responseText).result;
//         localStorage.setItem("business", JSON.stringify(business));
//         localStorage.setItem("business-date", JSON.stringify(Date.now()));
//         getBanners();
//       }
//     };
//     xhr.send();
//   }

//   async function getBanners() {
//     let url_eosio = "https://api-leap.eospglmlt.com/v1/chain/get_table_rows";
//     let xhr = new XMLHttpRequest();
//     xhr.open("POST", url_eosio);
//     xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
//     let data =
//       '{"json":true, "code": "eosmarketplc", "table": "banner", "scope": "eosmarketplc"}';
//     xhr.onreadystatechange = function () {
//       if (xhr.readyState === 4) {
//         var z = JSON.parse(xhr.responseText);
//         bannerBusiness = z.rows.sort(
//           (b, a) => parseFloat(a.remains) - parseFloat(b.remains)
//         );
//         bannerBusiness.forEach(getData);
//       }
//     };
//     xhr.send(data);
//   }

//   async function getData(value) {
//     let i;
//     for (i = 0; i < business.length; i++) {
//       if (business[i].account === value.account) {
//         // console.log("found", value.account);
//         await getInfo(business[i]._id, value.account);
//         return true;
//       }
//     }
//   }

//   async function getInfo(id, accountName) {
//     let url = "https://eosmarketplace.io/api/business/" + id;
//     let xhr = new XMLHttpRequest();
//     xhr.open("GET", url);
//     xhr.onreadystatechange = function () {
//       if (xhr.readyState === 4) {
//         let data = JSON.parse(xhr.responseText).result;
//         // console.log("banner info", data);
//         // banners.set(accountName, data);
//         // banners.push({accountName: data});
//         // banners = [...banners, {accountName: data}]
//         for (var x = 0, max = bannerBusiness.length; x < max; x++) {
//           if (bannerBusiness[x].account === accountName) {
//             // bannerBusiness[x].data = data;
//             bannerBusiness[x].data = data;
//           }
//         }
//       }
//     };
//     xhr.send();
//   }
</script>

<div class="marketplace_landing_container">
  <div id="banners" class="banners">
    {#if !hidden}
      {#each bannerBusiness as b}
        {#if b.account}
          <div class="business_banner">
            <div class="image">
              <a
                rel="noreferrer"
                href="https://eosmarketplace.io/#/business/{b.account}"
                target="_blank"
              >
                <img
                  alt="business_banner"
                  src="https://eosmarketplace.io{b.image}"
                />
              </a>
              <div class="category_label base_color">
                <i
                  class="fas fa-concierge-bell"
                  aria-hidden="true"
                />{b.category}
              </div>
            </div>
            <div class="info">
              <h3>{b.title}</h3>
              <h4>{b.description}</h4>
            </div>
          </div>
        {/if}
      {/each}
    {/if}
  </div>
</div>

<style>
  /*!
 * Cropper.js v1.5.9
 * https://fengyuanchen.github.io/cropperjs
 *
 * Copyright 2015-present Chen Fengyuan
 * Released under the MIT license
 *
 * Date: 2020-09-10T13:16:21.689Z
 */
  .cropper-container {
    direction: ltr;
    font-size: 0;
    line-height: 0;
    position: relative;
    -ms-touch-action: none;
    touch-action: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  .cropper-container img {
    display: block;
    height: 100%;
    image-orientation: 0deg;
    max-height: none !important;
    max-width: none !important;
    min-height: 0 !important;
    min-width: 0 !important;
    width: 100%;
  }
  .cropper-canvas,
  .cropper-crop-box,
  .cropper-drag-box,
  .cropper-modal,
  .cropper-wrap-box {
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  .cropper-canvas,
  .cropper-wrap-box {
    overflow: hidden;
  }
  .cropper-drag-box {
    background-color: #fff;
    opacity: 0;
  }
  .cropper-modal {
    background-color: #000;
    opacity: 0.5;
  }
  .cropper-view-box {
    display: block;
    height: 100%;
    outline: 1px solid #39f;
    outline-color: rgba(51, 153, 255, 0.75);
    overflow: hidden;
    width: 100%;
  }
  .cropper-dashed {
    border: 0 dashed #eee;
    display: block;
    opacity: 0.5;
    position: absolute;
  }
  .cropper-dashed.dashed-h {
    border-bottom-width: 1px;
    border-top-width: 1px;
    height: 33.33333%;
    left: 0;
    top: 33.33333%;
    width: 100%;
  }
  .cropper-dashed.dashed-v {
    border-left-width: 1px;
    border-right-width: 1px;
    height: 100%;
    left: 33.33333%;
    top: 0;
    width: 33.33333%;
  }
  .cropper-center {
    display: block;
    height: 0;
    left: 50%;
    opacity: 0.75;
    position: absolute;
    top: 50%;
    width: 0;
  }
  .cropper-center:after,
  .cropper-center:before {
    background-color: #eee;
    content: " ";
    display: block;
    position: absolute;
  }
  .cropper-center:before {
    height: 1px;
    left: -3px;
    top: 0;
    width: 7px;
  }
  .cropper-center:after {
    height: 7px;
    left: 0;
    top: -3px;
    width: 1px;
  }
  .cropper-face,
  .cropper-line,
  .cropper-point {
    display: block;
    height: 100%;
    opacity: 0.1;
    position: absolute;
    width: 100%;
  }
  .cropper-face {
    background-color: #fff;
    left: 0;
    top: 0;
  }
  .cropper-line {
    background-color: #39f;
  }
  .cropper-line.line-e {
    cursor: ew-resize;
    right: -3px;
    top: 0;
    width: 5px;
  }
  .cropper-line.line-n {
    cursor: ns-resize;
    height: 5px;
    left: 0;
    top: -3px;
  }
  .cropper-line.line-w {
    cursor: ew-resize;
    left: -3px;
    top: 0;
    width: 5px;
  }
  .cropper-line.line-s {
    bottom: -3px;
    cursor: ns-resize;
    height: 5px;
    left: 0;
  }
  .cropper-point {
    background-color: #39f;
    height: 5px;
    opacity: 0.75;
    width: 5px;
  }
  .cropper-point.point-e {
    cursor: ew-resize;
    margin-top: -3px;
    right: -3px;
    top: 50%;
  }
  .cropper-point.point-n {
    cursor: ns-resize;
    left: 50%;
    margin-left: -3px;
    top: -3px;
  }
  .cropper-point.point-w {
    cursor: ew-resize;
    left: -3px;
    margin-top: -3px;
    top: 50%;
  }
  .cropper-point.point-s {
    bottom: -3px;
    cursor: s-resize;
    left: 50%;
    margin-left: -3px;
  }
  .cropper-point.point-ne {
    cursor: nesw-resize;
    right: -3px;
    top: -3px;
  }
  .cropper-point.point-nw {
    cursor: nwse-resize;
    left: -3px;
    top: -3px;
  }
  .cropper-point.point-sw {
    bottom: -3px;
    cursor: nesw-resize;
    left: -3px;
  }
  .cropper-point.point-se {
    bottom: -3px;
    cursor: nwse-resize;
    height: 20px;
    opacity: 1;
    right: -3px;
    width: 20px;
  }
  @media (min-width: 768px) {
    .cropper-point.point-se {
      height: 15px;
      width: 15px;
    }
  }
  @media (min-width: 992px) {
    .cropper-point.point-se {
      height: 10px;
      width: 10px;
    }
  }
  @media (min-width: 1200px) {
    .cropper-point.point-se {
      height: 5px;
      opacity: 0.75;
      width: 5px;
    }
  }
  .cropper-point.point-se:before {
    background-color: #39f;
    bottom: -50%;
    content: " ";
    display: block;
    height: 200%;
    opacity: 0;
    position: absolute;
    right: -50%;
    width: 200%;
  }
  .cropper-invisible {
    opacity: 0;
  }
  .cropper-bg {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQAQMAAAAlPW0iAAAAA3NCSVQICAjb4U/gAAAABlBMVEXMzMz////TjRV2AAAACXBIWXMAAArrAAAK6wGCiw1aAAAAHHRFWHRTb2Z0d2FyZQBBZG9iZSBGaXJld29ya3MgQ1M26LyyjAAAABFJREFUCJlj+M/AgBVhF/0PAH6/D/HkDxOGAAAAAElFTkSuQmCC");
  }
  .cropper-hide {
    display: block;
    height: 0;
    position: absolute;
    width: 0;
  }
  .cropper-hidden {
    display: none !important;
  }
  .cropper-move {
    cursor: move;
  }
  .cropper-crop {
    cursor: crosshair;
  }
  .cropper-disabled .cropper-drag-box,
  .cropper-disabled .cropper-face,
  .cropper-disabled .cropper-line,
  .cropper-disabled .cropper-point {
    cursor: not-allowed;
  }
  @charset "UTF-8";
  @import url("https://fonts.googleapis.com/css?family=Roboto:400,500,700,900&display=swap");
  body {
    font-family: Roboto, sans-serif;
    overflow-y: auto;
    overflow-x: hidden;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
  }
  * {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
  input {
    outline: none;
  }
  input[type="number"]::-webkit-inner-spin-button,
  input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type="number"] {
    -moz-appearance: textfield;
  }
  button {
    cursor: pointer;
    outline: none;
    border: none;
  }
  table {
    border-spacing: 0;
    border-collapse: collapse;
  }
  table td,
  table th {
    border: 1px solid grey;
  }
  table th {
    padding: 2px 5px;
    background: #d3d3d3;
  }
  table td {
    padding: 0 5px;
  }
  .wallets-panel {
    width: 100%;
  }
  .wallets-panel .list {
    display: flex;
    justify-content: space-around;
  }
  .wallets-panel .list .wallet-view {
    text-align: center;
  }
  .btn-lynx {
    background: url(lynx.a9652074.png) no-repeat;
    background-size: 100% 100%;
    width: 52px;
    height: 52px;
  }
  .btn-scatter {
    background: url(scatter.b15a6e60.png) no-repeat;
    background-size: 100% 100%;
  }
  .btn-scatter,
  .btn-tp {
    width: 52px;
    height: 52px;
  }
  .btn-tp {
    background: url(tp.4ea34634.png) no-repeat;
    background-size: 100% 100%;
  }
  .btn-wombat {
    background: url(wombat.4cb88db8.png) no-repeat;
    background-size: 100% 100%;
    width: 52px;
    height: 52px;
  }
  .lib-rel-box {
    position: relative;
    width: 100%;
    height: 100%;
  }
  .lib-hbox {
    display: flex;
    flex-flow: row nowrap;
  }
  .lib-vbox {
    align-content: center;
  }
  .lib-vbox,
  .lib-vbox-right {
    display: flex;
    flex-flow: column nowrap;
  }
  .lib-vbox-right {
    align-content: flex-start;
  }
  .lib-align-center {
    align-items: center;
  }
  .lib-align-start {
    align-items: flex-start;
  }
  .lib-align-end {
    align-items: flex-end;
  }
  .lib-justify-start {
    justify-content: flex-start;
  }
  .lib-justify-center {
    justify-content: center;
  }
  .lib-justify-end {
    justify-content: flex-end;
  }
  .lib-comp-disabled {
    pointer-events: none;
    opacity: 0.5;
  }
  .text-center {
    text-align: center;
  }
  .lib-btn {
    font-weight: 500;
    font-size: 13px;
    position: relative;
    padding: 6px 25px;
    border: 1px solid #fff;
    border-radius: 8px;
    z-index: 1;
    color: #595959;
    background: #fff;
    box-shadow: 0 0 5px -2px #000;
  }
  .lib-btn:hover {
    box-shadow: 1px 1px 5px -1px #000;
  }
  .lib-btn:active {
    box-shadow: inset 0 0 5px -1px #000;
  }
  .lib-btn-busy,
  .lib-btn-disabled {
    pointer-events: none;
    filter: grayscale(100%);
  }
  .lib-btn-busy:after,
  .lib-btn-busy:before {
    content: "";
    position: absolute;
  }
  .lib-btn-busy:before {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(239, 148, 34, 0.4);
    z-index: 0;
  }
  .lib-btn-busy:after {
    left: 50%;
    top: 50%;
    box-sizing: border-box;
    display: block;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    z-index: 1;
    border-color: #fff transparent;
    border-style: solid;
    border-width: 5px;
    animation: lds-dual-ring 0.6s linear infinite;
  }
  @keyframes lds-dual-ring {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    to {
      transform: translate(-50%, -50%) rotate(1turn);
    }
  }
  .lib-image-disabled {
    filter: grayscale(100%);
  }
  .modal-link {
    font-weight: 700;
    font-size: 14px;
    text-decoration-line: underline;
    color: #222;
    cursor: pointer;
  }
  .modal-link:hover {
    color: #f52a4f;
  }
  .lib-scrollbar-style::-webkit-scrollbar {
    width: 8px;
  }
  .lib-scrollbar-style::-webkit-scrollbar-track {
    background: rgba(0, 0, 0, 0.4);
  }
  .lib-scrollbar-style::-webkit-scrollbar-thumb {
    background: hsla(0, 0%, 100%, 0.1);
  }
  .lib-scrollbar-style::-webkit-scrollbar-thumb:hover {
    background: hsla(0, 0%, 100%, 0.2);
  }
  .lib-vscroll {
    overflow-y: auto;
    overflow-x: hidden;
    min-height: 0;
  }
  .cabinet-page {
    background: #595959;
  }
  .title_style {
    position: relative;
    margin: 14px;
    display: inline-block;
    font-size: 16px;
    font-weight: 700;
  }
  .cabinet-page .customer_history {
    width: 30px;
    height: 30px;
    background: url(history_btn.65d43808.png) no-repeat 0 0;
    background-size: 90px;
  }
  .cabinet-page .customer_history:hover {
    background-position: -30px 0;
  }
  .cabinet-page .customer_history:active {
    background-position: -60px 0;
  }
  .cabinet-page .edit_button {
    width: 30px;
    height: 30px;
    background: url(edit_btn.b0abc2b9.png) no-repeat 0 0;
    background-size: 90px;
  }
  .cabinet-page .edit_button:hover {
    background-position: -30px 0;
  }
  .cabinet-page .edit_button:active {
    background-position: -60px 0;
  }
  .cabinet-page .delete_button {
    width: 30px;
    height: 30px;
    background: url(delete_btn.1284e414.png) no-repeat 0 0;
    background-size: 90px;
    margin-left: 4px;
  }
  .cabinet-page .delete_button:hover {
    background-position: -30px 0;
  }
  .cabinet-page .delete_button:active {
    background-position: -60px 0;
  }
  .cabinet-page .empty_block {
    padding: 50px;
    color: grey;
    background-color: hsla(0, 0%, 50.2%, 0.08);
  }
  .cabinet-page .header {
    position: fixed;
    z-index: 5;
    background: linear-gradient(90deg, #232526, #414345);
    height: 40px;
    width: 100%;
    max-width: 1280px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    color: #fff;
    font-weight: 700;
    font-size: 13px;
    padding: 5px;
  }
  .cabinet-page .header .logout_button {
    width: 30px;
    height: 30px;
    background: url(logout_btn.ded2ff22.png) no-repeat 0 0;
    background-size: 90px;
    margin-left: 10px;
  }
  .cabinet-page .header .logout_button:hover {
    background-position: -30px 0;
  }
  .cabinet-page .header .logout_button:active {
    background-position: -60px 0;
  }
  .cabinet-page .header .balances {
    text-align: right;
    margin-right: auto;
    margin-left: 12px;
  }
  .cabinet-page .header .logo_in_app {
    width: 26px;
    height: 32px;
  }
  .cabinet-page .header .logo_in_app img {
    width: 100%;
  }
  .cabinet-page .header .account {
    align-items: center;
    text-align: right;
    color: #ffc837;
  }
  .cabinet-page .header .connection-icon-btn {
    color: #ffc837;
    margin-right: 10px;
  }
  .cabinet-page .header .connection-icon-btn:hover {
    color: red;
  }
  .cabinet-page .body {
    width: 100%;
    max-width: 1280px;
    padding: 40px 5px 20px;
    height: calc(100% - 50px);
    overflow-y: auto;
    background: #fff;
    background-size: 100%;
  }
  .cabinet-page .body iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    z-index: 6;
    border: none;
    outline: none;
    left: 0;
  }
  .cabinet-page .body h4 {
    color: #bdbdbd;
    margin: 10px 0;
    font-size: 12px;
  }
  .cabinet-page .body .nav_panel {
    position: fixed;
    z-index: 1;
    bottom: 0;
    height: 50px;
    background-color: #282a2b;
    width: 100%;
    color: #fff;
    max-width: 1280px;
    margin-left: -5px;
    display: flex;
    justify-content: space-around;
    font-size: 13px;
    font-weight: 700;
  }
  .cabinet-page .body .nav_panel .nav_button {
    line-height: 50px;
    cursor: pointer;
    width: 50%;
    text-align: center;
  }
  .cabinet-page .body .nav_panel .nav_button.active {
    background: linear-gradient(90deg, #f91942 30%, #f0cb35 130%);
    color: #fff;
  }
  .cabinet-page .body #directors {
    padding-top: 5px;
  }
  .cabinet-page .body .board {
    margin-bottom: 4px;
    padding: 4px;
    background: #fff;
    font-size: 13px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.3);
    border-radius: 4px;
  }
  .cabinet-page .body .board .lib-btn-cancel,
  .cabinet-page .body .board .lib-btn-contract,
  .cabinet-page .body .board .lib-btn-standard {
    width: 65px;
    font-size: 13px;
    padding: 0 4px;
    height: 34px;
    margin: 0 0 0 4px;
  }
  .cabinet-page .body .board.horizontal {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cabinet-page .body .board.horizontal .client {
    text-align: left;
  }
  .cabinet-page .body .board.horizontal .type {
    width: 106px;
    text-align: left;
  }
  .cabinet-page .body .board.horizontal .balance_change {
    width: 90px;
  }
  .cabinet-page .body .board input {
    padding: 5px;
    width: 150px;
    margin: 5px 0;
  }
  .cabinet-page .body .board .button_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    text-align: right;
  }
  .cabinet-page .body .board .button_box button {
    margin-left: 4px;
  }
  .cabinet-page #main_settings .desc {
    font-size: 14px;
    color: #a2a2a2;
    margin: 10px;
  }
  .cabinet-page #main_settings .section {
    text-align: center;
    border-bottom: 1px solid #d7d7d7;
    padding: 20px 0;
  }
  .cabinet-page #main_settings .section input {
    font-size: 14px;
    padding: 5px;
    margin: 5px;
  }
  .cabinet-page #main_settings .section .rex {
    margin-top: 10px;
    display: flex;
    justify-content: center;
  }
  .cabinet-page #main_settings .section .rex .rex_sec {
    margin: 0 20px;
  }
  .cabinet-page #settings .desc {
    font-size: 14px;
    color: #a2a2a2;
    margin: 10px;
  }
  .cabinet-page #settings .section {
    text-align: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #d7d7d7;
    padding: 20px 0;
  }
  .cabinet-page #settings .section .current_agent {
    font-size: 20px;
    color: #2795fc;
    margin-bottom: 26px;
  }
  .cabinet-page #rewards {
    max-width: 600px;
    margin: 0 auto;
    text-align: left;
  }
  .cabinet-page #rewards .unstaking {
    text-align: left;
  }
  .cabinet-page #rewards .button_box input {
    width: 98px;
    padding: 0 4px;
    height: 34px;
    border: 1px solid grey;
  }
  .cabinet-page #rewards .datetime {
    font-size: 12px;
    color: grey;
    text-align: left;
  }
  .cabinet-page #rewards .estimate_view {
    display: flex;
    justify-content: space-between;
  }
  .cabinet-page #rewards .estimate_view .board {
    width: 49.5%;
  }
  .cabinet-page #rewards .payout_block {
    text-align: center;
  }
  .cabinet-page #rewards .payout_block div:first-child {
    margin-bottom: 10px;
    height: 34px;
  }
  .cabinet-page #rewards .payout_block div:last-child {
    font-weight: 700;
  }
  .cabinet-page #rewards .info {
    text-align: center;
  }
  .cabinet-page .content {
    text-align: center;
    height: 100%;
  }
  .cabinet-page #businesses,
  .cabinet-page #customer_history,
  .cabinet-page #customers,
  .cabinet-page #deals,
  .cabinet-page #loan_form {
    height: 100%;
    padding-top: 45px;
  }
  .cabinet-page #businesses #deal_table_body,
  .cabinet-page #customer_history #deal_table_body,
  .cabinet-page #customers #deal_table_body,
  .cabinet-page #deals #deal_table_body,
  .cabinet-page #loan_form #deal_table_body {
    max-height: calc(100% - 17px);
    min-width: 369px;
    justify-content: space-between;
    overflow-x: visible;
    overflow-y: auto;
    border-top: 2px solid grey;
  }
  .cabinet-page #businesses #deal_table_body ::-webkit-scrollbar-track,
  .cabinet-page #customer_history #deal_table_body ::-webkit-scrollbar-track,
  .cabinet-page #customers #deal_table_body ::-webkit-scrollbar-track,
  .cabinet-page #deals #deal_table_body ::-webkit-scrollbar-track,
  .cabinet-page #loan_form #deal_table_body ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }
  .cabinet-page #businesses .row,
  .cabinet-page #customer_history .row,
  .cabinet-page #customers .row,
  .cabinet-page #deals .row,
  .cabinet-page #loan_form .row {
    cursor: pointer;
  }
  .cabinet-page #businesses .head_row,
  .cabinet-page #businesses .row,
  .cabinet-page #customer_history .head_row,
  .cabinet-page #customer_history .row,
  .cabinet-page #customers .head_row,
  .cabinet-page #customers .row,
  .cabinet-page #deals .head_row,
  .cabinet-page #deals .row,
  .cabinet-page #loan_form .head_row,
  .cabinet-page #loan_form .row {
    display: flex;
    justify-content: flex-start;
    font-size: 0;
  }
  .cabinet-page #businesses .head_row div,
  .cabinet-page #businesses .row div,
  .cabinet-page #customer_history .head_row div,
  .cabinet-page #customer_history .row div,
  .cabinet-page #customers .head_row div,
  .cabinet-page #customers .row div,
  .cabinet-page #deals .head_row div,
  .cabinet-page #deals .row div,
  .cabinet-page #loan_form .head_row div,
  .cabinet-page #loan_form .row div {
    padding: 10px 2px;
    text-align: left;
    border-right: 1px solid hsla(0, 0%, 70.6%, 0.4);
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
  }
  .cabinet-page #businesses .head_row div:last-child,
  .cabinet-page #businesses .row div:last-child,
  .cabinet-page #customer_history .head_row div:last-child,
  .cabinet-page #customer_history .row div:last-child,
  .cabinet-page #customers .head_row div:last-child,
  .cabinet-page #customers .row div:last-child,
  .cabinet-page #deals .head_row div:last-child,
  .cabinet-page #deals .row div:last-child,
  .cabinet-page #loan_form .head_row div:last-child,
  .cabinet-page #loan_form .row div:last-child {
    border-right: none;
  }
  .cabinet-page #businesses .head_row .col_actions,
  .cabinet-page #businesses .row .col_actions,
  .cabinet-page #customer_history .head_row .col_actions,
  .cabinet-page #customer_history .row .col_actions,
  .cabinet-page #customers .head_row .col_actions,
  .cabinet-page #customers .row .col_actions,
  .cabinet-page #deals .head_row .col_actions,
  .cabinet-page #deals .row .col_actions,
  .cabinet-page #loan_form .head_row .col_actions,
  .cabinet-page #loan_form .row .col_actions {
    border-right: none;
  }
  .cabinet-page #businesses .head_row .col_actions button,
  .cabinet-page #businesses .row .col_actions button,
  .cabinet-page #customer_history .head_row .col_actions button,
  .cabinet-page #customer_history .row .col_actions button,
  .cabinet-page #customers .head_row .col_actions button,
  .cabinet-page #customers .row .col_actions button,
  .cabinet-page #deals .head_row .col_actions button,
  .cabinet-page #deals .row .col_actions button,
  .cabinet-page #loan_form .head_row .col_actions button,
  .cabinet-page #loan_form .row .col_actions button {
    margin: 5px 0 0;
    padding: 7px;
    font-size: 14px;
  }
  .cabinet-page #businesses .row:nth-child(odd),
  .cabinet-page #customer_history .row:nth-child(odd),
  .cabinet-page #customers .row:nth-child(odd),
  .cabinet-page #deals .row:nth-child(odd),
  .cabinet-page #loan_form .row:nth-child(odd) {
    background-color: rgba(0, 0, 0, 0.035);
  }
  .cabinet-page #businesses .row:hover,
  .cabinet-page #customer_history .row:hover,
  .cabinet-page #customers .row:hover,
  .cabinet-page #deals .row:hover,
  .cabinet-page #loan_form .row:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  .cabinet-page #businesses .head_row,
  .cabinet-page #customer_history .head_row,
  .cabinet-page #customers .head_row,
  .cabinet-page #deals .head_row,
  .cabinet-page #loan_form .head_row {
    font-weight: 700;
  }
  .cabinet-page #businesses .col_datetime,
  .cabinet-page #businesses .col_type,
  .cabinet-page #customer_history .col_datetime,
  .cabinet-page #customer_history .col_type,
  .cabinet-page #customers .col_datetime,
  .cabinet-page #customers .col_type,
  .cabinet-page #deals .col_datetime,
  .cabinet-page #deals .col_type,
  .cabinet-page #loan_form .col_datetime,
  .cabinet-page #loan_form .col_type {
    min-width: 140px;
  }
  .cabinet-page #businesses .col_debt,
  .cabinet-page #businesses .col_quantity,
  .cabinet-page #customer_history .col_debt,
  .cabinet-page #customer_history .col_quantity,
  .cabinet-page #customers .col_debt,
  .cabinet-page #customers .col_quantity,
  .cabinet-page #deals .col_debt,
  .cabinet-page #deals .col_quantity,
  .cabinet-page #loan_form .col_debt,
  .cabinet-page #loan_form .col_quantity {
    min-width: 114px;
  }
  .cabinet-page #businesses .col_memo,
  .cabinet-page #customer_history .col_memo,
  .cabinet-page #customers .col_memo,
  .cabinet-page #deals .col_memo,
  .cabinet-page #loan_form .col_memo {
    min-width: 226px;
  }
  .cabinet-page #businesses .col_agent,
  .cabinet-page #businesses .col_agent1,
  .cabinet-page #businesses .col_customer,
  .cabinet-page #customer_history .col_agent,
  .cabinet-page #customer_history .col_agent1,
  .cabinet-page #customer_history .col_customer,
  .cabinet-page #customers .col_agent,
  .cabinet-page #customers .col_agent1,
  .cabinet-page #customers .col_customer,
  .cabinet-page #deals .col_agent,
  .cabinet-page #deals .col_agent1,
  .cabinet-page #deals .col_customer,
  .cabinet-page #loan_form .col_agent,
  .cabinet-page #loan_form .col_agent1,
  .cabinet-page #loan_form .col_customer {
    min-width: 155px;
  }
  .cabinet-page #businesses .col_actions,
  .cabinet-page #customer_history .col_actions,
  .cabinet-page #customers .col_actions,
  .cabinet-page #deals .col_actions,
  .cabinet-page #loan_form .col_actions {
    min-width: 70px;
  }
  .cabinet-page #businesses .col_email,
  .cabinet-page #businesses .col_telegram,
  .cabinet-page #customer_history .col_email,
  .cabinet-page #customer_history .col_telegram,
  .cabinet-page #customers .col_email,
  .cabinet-page #customers .col_telegram,
  .cabinet-page #deals .col_email,
  .cabinet-page #deals .col_telegram,
  .cabinet-page #loan_form .col_email,
  .cabinet-page #loan_form .col_telegram {
    min-width: 200px;
    user-select: all;
  }
  .cabinet-page #businesses {
    text-align: center;
    padding-top: 45px;
  }
  .cabinet-page #businesses #deal_table_body {
    max-height: calc(100% - 70px);
  }
  .cabinet-page #businesses #deal_table_body,
  .cabinet-page #businesses .row {
    cursor: default;
  }
  .cabinet-page #businesses #deal_table_body .col_actions,
  .cabinet-page #businesses .row .col_actions {
    display: flex;
    align-items: center;
    border-right: none;
  }
  .cabinet-page #businesses #deal_table_body .col_actions button,
  .cabinet-page #businesses .row .col_actions button {
    margin: 0;
  }
  .cabinet-page #businesses #deal_table_body .col_actions .lib-btn,
  .cabinet-page #businesses .row .col_actions .lib-btn {
    margin: 0 5px 0 0;
    padding: 6px 25px;
  }
  .cabinet-page #businesses #deal_table_body .col,
  .cabinet-page #businesses .head_row .col {
    flex-grow: 1;
    flex-basis: 0;
  }
  .cabinet-page #businesses .buttons {
    display: flex;
    align-items: center;
  }
  .cabinet-page #businesses .buttons button {
    margin-left: 5px;
  }
  .cabinet-page #deals {
    height: 100%;
    padding-top: 45px;
  }
  .cabinet-page #deals #deal_table_body {
    min-width: 1270px;
    max-height: calc(100% - 70px);
  }
  .cabinet-page #deals .board {
    padding: 0 5px;
  }
  .cabinet-page #deals .deal_info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 5px 0;
  }
  .cabinet-page #deals .info {
    font-size: 12px;
    color: grey;
    margin-right: 5px;
  }
  .cabinet-page #deals .client {
    width: 45%;
    font-size: 16px;
    font-weight: 700;
    text-align: left;
  }
  .cabinet-page #deals .client .deal_time {
    font-size: 12px;
    font-weight: 400;
    color: grey;
  }
  .cabinet-page #deals .amount {
    width: 35%;
    font-size: 14px;
    color: #2f80ed;
    font-weight: 700;
    text-align: right;
  }
  .cabinet-page #deals .amount .deal_type_0 {
    color: red;
    font-size: 12px;
    font-weight: 400;
  }
  .cabinet-page #deals .amount .deal_type_1 {
    color: #ff4130;
    font-size: 12px;
    font-weight: 400;
  }
  .cabinet-page #deals .amount .deal_type_2 {
    color: green;
    font-size: 12px;
    font-weight: 400;
  }
  .cabinet-page #deals .amount .deal_pay {
    font-size: 10px;
    color: green;
  }
  .cabinet-page #deals .agent,
  .cabinet-page #deals .memo {
    border-top: 1px solid #f2f2f2;
  }
  .cabinet-page #deals .memo {
    display: block;
    text-align: justify;
    overflow: hidden;
  }
  .cabinet-page #deals .confirm_row {
    border-top: 1px solid #f2f2f2;
  }
  .cabinet-page #deals .confirm_row .client {
    width: 75%;
    font-size: 12px;
    font-weight: 400;
    color: grey;
  }
  .cabinet-page #deals .confirm_row .client .warn {
    color: red;
    font-weight: 700;
  }
  .cabinet-page #deals .status {
    width: 28%;
    text-align: right;
    align-self: center;
    font-size: 12px;
  }
  .cabinet-page.readonly #deals #deal_table_body {
    max-height: calc(100% - 17px);
  }
  .cabinet-page #loan_form_container {
    padding-top: 25px;
  }
  .cabinet-page #loan_form {
    text-align: center;
    max-width: 400px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px 0;
  }
  .cabinet-page #loan_form input:not([type="radio"]),
  .cabinet-page #loan_form option,
  .cabinet-page #loan_form select {
    padding: 0 4px;
    height: 34px;
    background: none;
    border: 1px solid grey;
    margin: 10px 0;
    width: 80%;
    font-size: 16px;
  }
  .cabinet-page #loan_form .accountBalanceView {
    padding: 0 15px;
  }
  .cabinet-page #loan_form .agent_input {
    width: 60% !important;
  }
  .cabinet-page #loan_form .percent_input {
    width: 19% !important;
    margin-left: 1% !important;
  }
  .cabinet-page #loan_form #agent_select {
    display: flex;
    flex-direction: column;
    text-align: left;
    padding: 0 10%;
  }
  .cabinet-page #loan_form #agent_select label {
    padding: 3px 0;
  }
  .cabinet-page #loan_form #agent_select label input {
    padding-right: 5px;
  }
  .cabinet-page #loan_form #deal_table_body .col,
  .cabinet-page #loan_form .head_row .col {
    flex-grow: 1;
    flex-basis: 0;
  }
  .cabinet-page #loan_form textarea {
    width: 80%;
    height: 100px;
    padding: 4px;
    border: 1px solid #bebebe;
  }
  .cabinet-page #loan_form button {
    margin: 10px;
  }
  .cabinet-page #loan_form .loan_type_select {
    display: flex;
    justify-content: space-around;
  }
  .cabinet-page #loan_form .loan_type_select label {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .cabinet-page #loan_form .loan_type_select label input {
    margin-right: 4px;
  }
  .cabinet-page #customer_history {
    padding-top: 45px;
  }
  .cabinet-page #customer_history #deal_table_body,
  .cabinet-page #customer_history .row {
    cursor: default;
  }
  .cabinet-page #customer_history #deal_table_body .col,
  .cabinet-page #customer_history .head_row .col {
    flex-grow: 1;
    flex-basis: 0;
  }
  .cabinet-page #customer_history .info {
    font-size: 12px;
    color: grey;
    margin-right: 5px;
  }
  .cabinet-page #customer_history .block_header .client {
    color: #c17a00;
    font-weight: 700;
  }
  .cabinet-page #customer_history .datetime {
    font-size: 12px;
    color: grey;
  }
  .cabinet-page #customers {
    padding-top: 45px;
  }
  .cabinet-page #customers #deal_table_body button,
  .cabinet-page #customers .row button {
    margin: 0;
  }
  .cabinet-page #customers #deal_table_body .col,
  .cabinet-page #customers .head_row .col {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cabinet-page #customers #deal_table_body .col div,
  .cabinet-page #customers .head_row .col div {
    border: none;
    padding: 0;
  }
  .cabinet-page #customers .row_header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .cabinet-page #customer_history .block_header,
  .cabinet-page .customers_filter,
  .cabinet-page .deals_filter {
    display: flex;
    padding: 10px 5px;
    border-bottom: 1px solid hsla(0, 0%, 66.7%, 0.56);
    position: fixed;
    width: 100%;
    margin-left: -5px;
    top: 40px;
    z-index: 2;
    height: 40px;
    align-items: center;
    background-color: #f2f2f2;
    max-width: 1280px;
  }
  .cabinet-page .filter .customers_filter input {
    background: #f2f2f2;
    border: none;
    width: 100%;
    padding: 3px;
  }
  .cabinet-page .filter .deals_filter [type="checkbox"]:checked,
  .cabinet-page .filter .deals_filter [type="checkbox"]:not(:checked) {
    display: none;
  }
  .cabinet-page .filter .deals_filter label {
    padding: 5px;
    background-color: #fff;
    cursor: pointer;
    border-radius: 4px;
    margin-right: 5px;
  }
  .cabinet-page .filter .deals_filter [type="checkbox"]:checked + label {
    background: #313234;
    color: #ffc837;
  }
  .cabinet-page .lib-btn-contract,
  .cabinet-page .lib-btn-standard {
    background: linear-gradient(90deg, #f91942 30%, #f0cb35 130%);
    border-radius: 4px;
    border: none;
    color: #fff;
    font-weight: 700;
    margin: 10px;
  }
  .cabinet-page .lib-btn-cancel {
    background: linear-gradient(90deg, #232526, #414345);
    border-radius: 4px;
    border: none;
    color: #fff;
    font-weight: 700;
    margin: 10px;
  }
  @media screen and (min-width: 1280px) {
    .cabinet-page .nav_panel {
      top: 41px;
      font-size: 14px;
      border-bottom: 1px solid #dadada;
    }
    .cabinet-page .filter #customer_history .block_header,
    .cabinet-page .filter .customers_filter,
    .cabinet-page .filter .deals_filter {
      top: 91px;
    }
    .cabinet-page .body {
      padding-top: 90px;
      height: 100%;
    }
    .cabinet-page #customer_history {
      padding-top: 0;
    }
    .cabinet-page #customer_history .block_header {
      display: flex;
      justify-content: space-evenly;
      height: 50px;
      border: none;
    }
  }
  #connect_to_mlt {
    padding-top: 20px;
  }
  #pay_form_container {
    padding-top: 25px;
  }
  #pay_form {
    max-width: 400px;
    background-color: #fff;
    border-radius: 10px;
    padding: 10px 0;
    text-align: center;
    margin: 0 auto;
  }
  #pay_form input,
  #pay_form select {
    padding: 0 4px;
    font-size: 12px;
    height: 34px;
    background: none;
    border: 1px solid grey;
    margin: 10px 0;
    width: 80%;
  }
  #pay_form textarea {
    width: 80%;
    height: 100px;
    padding: 4px;
    border: 1px solid #bebebe;
  }
  #pay_form button {
    margin: 10px;
  }
  #pay_form .loan_type_select {
    display: flex;
    justify-content: space-around;
  }
  #pay_form .loan_type_select label {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  #pay_form .loan_type_select label input {
    margin-right: 4px;
  }
  #pay_form .unavailable {
    color: red;
  }
  .auth-page,
  .loading-page {
    background: url(back_main_page.28ffa868.jpg) no-repeat;
    background-size: cover;
    background-position: 50%;
    color: #fff;
    padding: 10px;
    justify-content: center;
    font-size: 13px;
  }
  .auth-page input,
  .loading-page input {
    height: 34px;
    padding: 4px;
    width: 160px;
  }
  .auth-page label,
  .loading-page label {
    font-weight: 700;
  }
  .auth-page .login-form-row,
  .loading-page .login-form-row {
    margin-top: 10px;
  }
  .has_window .marketplace_cabinet_container {
    pointer-events: none;
  }
  .base_color {
    background: linear-gradient(-180deg, #f52a4f, #33001b) !important;
  }
  .base_text_color {
    color: #f52a4f;
  }
  #cabinet_body .lib-btn-backend,
  #cabinet_body .lib-btn-contract,
  #cabinet_body .lib-btn-ui,
  .has_window .lib-btn-backend,
  .has_window .lib-btn-contract,
  .has_window .lib-btn-ui,
  .marketplace_landing_container .lib-btn-contract,
  .menu_body .lib-btn-contract {
    border: none;
    color: #fff;
    font-weight: 700;
    margin: 0 auto;
    border-radius: 4px;
    transition: all 0.5s ease;
  }
  @media (max-width: 900px) {
    #cabinet_body .lib-btn-backend,
    #cabinet_body .lib-btn-contract,
    #cabinet_body .lib-btn-ui,
    .has_window .lib-btn-backend,
    .has_window .lib-btn-contract,
    .has_window .lib-btn-ui,
    .marketplace_landing_container .lib-btn-contract,
    .menu_body .lib-btn-contract {
      font-size: 14px;
    }
  }
  #cabinet_body .lib-btn-contract,
  .has_window .lib-btn-contract,
  .marketplace_landing_container .lib-btn-contract,
  .menu_body .lib-btn-contract {
    background: linear-gradient(-180deg, #f52a4f, #33001b);
  }
  #cabinet_body .lib-btn-contract:hover,
  .has_window .lib-btn-contract:hover,
  .marketplace_landing_container .lib-btn-contract:hover,
  .menu_body .lib-btn-contract:hover {
    background: linear-gradient(180deg, #f52a4f, #33001b);
  }
  #cabinet_body .lib-btn-backend,
  #cabinet_body .lib-btn-ui,
  .has_window .lib-btn-backend,
  .has_window .lib-btn-ui,
  .marketplace_landing_container .lib-btn-backend,
  .marketplace_landing_container .lib-btn-ui {
    color: #000;
  }
  #cabinet_body #pay_form_container {
    padding: 0 !important;
  }
  #cabinet_body #pay_form {
    max-width: 100%;
    text-align: left;
  }
  #cabinet_body #pay_form .form_title {
    font-size: 20px;
    margin: 0 0 20px;
    font-weight: 700;
  }
  #cabinet_body #pay_form .title_style {
    font-size: 26px;
    margin: 0 0 20px;
  }
  #cabinet_body #pay_form .info_container {
    border-bottom: 1px solid grey;
    margin-bottom: 20px;
  }
  #cabinet_body #pay_form .info_container div {
    margin: 20px 0;
  }
  #cabinet_body #pay_form .info_container div span {
    font-weight: 700;
    font-size: 18px;
  }
  .no_image_placeholder {
    width: 100%;
    height: calc(100% - 36px);
    min-height: 300px;
    position: relative;
  }
  .no_image_placeholder:before {
    content: "CLICK TO SETUP IMAGE";
    position: absolute;
    width: 100%;
    text-align: center;
    height: 100%;
    background-color: #faf8f8;
    border-radius: 5px;
    color: grey;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
    border: 1px solid #faf8f8;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .no_image_placeholder.invalid:before {
    border-color: red;
  }
  .win-base .new_loan_form {
    padding: 20px 40px;
  }
  .win-base .new_loan_form .accountBalanceView {
    padding-top: 15px;
  }
  .win-base .new_loan_form #cancel_button,
  .win-base .new_loan_form .loan_type_container {
    display: none;
  }
  .win-base .new_loan_form .agent_container {
    display: flex;
  }
  .win-base .new_loan_form .agent_container input:first-child {
    width: 250px;
  }
  .win-base .new_loan_form .agent_container input:last-child {
    margin-left: 20px;
  }
  .win-base .new_loan_form .buttons_container {
    text-align: center;
  }
  .win-base .new_loan_form .buttons_container #confirm_button {
    margin: 0 !important;
  }
  .win-base .new_loan_form input,
  .win-base .new_loan_form select,
  .win-base .new_loan_form textarea {
    height: 40px;
    line-height: 51px;
    padding: 0 20px;
    outline: none;
    font-size: 15px;
    color: grey;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    display: block;
    border: 1px solid #dbdbdb;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
    font-weight: 500;
    opacity: 1;
    border-radius: 3px;
    margin-bottom: 20px;
  }
  .win-base .new_loan_form input.invalid,
  .win-base .new_loan_form select.invalid,
  .win-base .new_loan_form textarea.invalid {
    border-color: red;
  }
  .win-base .new_loan_form .title_style {
    font-size: 26px;
    margin: 0 0 20px;
  }
  .win-base .new_loan_form select:disabled {
    background-color: hsla(0, 0%, 93.7%, 0.3);
  }
  .win-base .new_loan_form textarea {
    min-height: 100px;
    line-height: 20px;
    padding: 20px;
  }
  #cabinet_body #pay_form,
  .form_preview {
    border-radius: 4px;
    background-color: #fff;
    padding: 20px 40px;
  }
  #cabinet_body #pay_form .buttons,
  .form_preview .buttons {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  #cabinet_body #pay_form h5,
  .form_preview h5 {
    font-size: 15px;
    font-weight: 600;
    color: #333;
    margin-bottom: 17px;
  }
  #cabinet_body #pay_form i,
  .form_preview i {
    margin: 0 5px;
  }
  #cabinet_body #pay_form input,
  #cabinet_body #pay_form select,
  #cabinet_body #pay_form textarea,
  .form_preview input,
  .form_preview select,
  .form_preview textarea {
    height: 40px;
    line-height: 51px;
    padding: 0 20px;
    outline: none;
    font-size: 15px;
    color: grey;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    display: block;
    border: 1px solid #dbdbdb;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
    font-weight: 500;
    opacity: 1;
    border-radius: 3px;
  }
  #cabinet_body #pay_form input.invalid,
  #cabinet_body #pay_form select.invalid,
  #cabinet_body #pay_form textarea.invalid,
  .form_preview input.invalid,
  .form_preview select.invalid,
  .form_preview textarea.invalid {
    border-color: red;
  }
  #cabinet_body #pay_form select:disabled,
  .form_preview select:disabled {
    background-color: hsla(0, 0%, 93.7%, 0.3);
  }
  #cabinet_body #pay_form textarea,
  .form_preview textarea {
    min-height: 100px;
    line-height: 20px;
    padding: 20px;
  }
  #cabinet_body #pay_form .row,
  .form_preview .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
  #cabinet_body #pay_form .row .col,
  .form_preview .row .col {
    width: 100%;
    margin-left: 40px;
  }
  #cabinet_body #pay_form .row .col:first-child,
  .form_preview .row .col:first-child {
    margin-left: 0;
  }
  #cabinet_body #pay_form .row.with_image img,
  .form_preview .row.with_image img {
    width: 100%;
  }
  #cabinet_body #pay_form #searchLocationMap,
  .form_preview #searchLocationMap {
    width: 100%;
    height: calc(100% - 77px);
    min-height: 300px;
  }
  #cabinet_body #pay_form .options_container,
  .form_preview .options_container {
    display: flex;
    justify-content: space-between;
  }
  #cabinet_body #pay_form .options_container .business_option,
  .form_preview .options_container .business_option {
    width: 32%;
    min-height: 300px;
    background-color: #fff;
    border-radius: 3px;
    padding: 5px;
    position: relative;
  }
  #cabinet_body #pay_form .options_container .business_option.empty:before,
  .form_preview .options_container .business_option.empty:before {
    content: "OPTION NOT SET";
    line-height: 300px;
    position: absolute;
    width: 100%;
    height: 100%;
    text-align: center;
    color: hsla(0, 0%, 50.2%, 0.37);
    font-weight: 700;
    font-size: 20px;
  }
  #cabinet_body #pay_form .options_container .business_option img,
  .form_preview .options_container .business_option img {
    max-width: 100%;
    width: auto !important;
    max-height: 400px;
    display: block;
    margin: 0 auto;
  }
  #cabinet_body #pay_form .options_container img,
  .form_preview .options_container img {
    width: 100%;
  }
  .tip {
    font-style: normal;
    position: relative;
    top: -1px;
    left: 2px;
    display: inline-block;
    cursor: help;
    font-size: 11px;
    line-height: 0;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    color: #fff;
    text-align: center;
    padding: 0 !important;
    font-weight: 500;
  }
  .tip:after {
    content: "?";
    line-height: 19px;
    display: inline-block;
    position: relative;
    text-align: center;
    -moz-transform: translateY(-1px);
  }
  .tip-content {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, calc(-100% - 20px));
    -ms-transform: translate(-50%, -100%);
    background: #333;
    color: #fff;
    padding: 8px;
    min-width: 200px;
    max-width: 200px;
    font-size: 13px;
    border-radius: 4px;
    line-height: 19px;
    pointer-events: none;
    z-index: 999;
    text-align: center;
    opacity: 0;
    visibility: hidden;
    transition: all 0.3s;
  }
  .tip-content:after {
    font-family: FontAwesome;
    content: "ïƒ";
    position: absolute;
    bottom: 3px;
    left: 50%;
    font-size: 22px;
    color: #333;
    transform: translate(-50%, 50%);
  }
  .tip:hover .tip-content {
    opacity: 1;
    visibility: visible;
    transform: translate(-50%, calc(-100% - 8px));
    -ms-transform: translate(-50%, -115%);
  }
  .wait_image_loader {
    position: relative;
    height: 200px;
  }
  .wait_image_loader img {
    display: none;
  }
  .wait_image_loader:before {
    content: "";
    position: absolute;
    border: 4px solid #f3f3f3;
    border-top-color: #3498db;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    animation: spin 2s linear infinite;
    top: calc(50% - 14px);
    left: calc(50% - 14px);
  }
  .wait_image_loader.no_image:before {
    content: "NO IMAGE";
    border: none;
    animation: none;
    width: 100%;
    left: 0;
    text-align: center;
    font-weight: 700;
  }
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(1turn);
    }
  }
  .editable .form_preview .business_option.empty {
    cursor: pointer;
    opacity: 0.8;
  }
  .editable .form_preview .business_option.empty:before {
    content: "+";
    font-size: 80px;
  }
  .editable .form_preview .business_option.empty:hover {
    opacity: 1;
  }
  .editable img {
    cursor: pointer;
  }
  .editable .options_container img {
    cursor: auto;
  }
  .business_ad_form .bannersPositionsContainer {
    width: 260px;
    min-width: 260px;
    position: relative;
    margin-right: 20px;
    margin-top: -8px;
  }
  .business_ad_form .form_preview {
    min-width: 220px;
  }
  .business_ad_form .business_banner {
    height: 50px;
    position: absolute;
    display: flex;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #efefef;
    background: #fff;
    transition: all 1s;
    transition-delay: 0.3s;
    box-shadow: 0 0 24px -15px #000;
  }
  .business_ad_form .business_banner .info {
    display: flex;
    align-items: center;
    height: 100%;
    padding-left: 10px;
    overflow: hidden;
    position: relative;
  }
  .business_ad_form .business_banner .info h4,
  .business_ad_form .business_banner .info h5 {
    white-space: nowrap;
  }
  .business_ad_form .business_banner .info h4 {
    color: grey;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.4;
    overflow: auto;
  }
  .business_ad_form .business_banner .image {
    position: relative;
    overflow: hidden;
    display: table;
    height: 50px;
  }
  .business_ad_form .business_banner .image img {
    height: 50px;
  }
  .business_ad_form .business_banner .image.wait_image_loader {
    width: 89px;
  }
  .business_ad_form .business_banner.my {
    border-color: red;
    z-index: 1;
  }
  .business_ad_form .business_banner.out {
    opacity: 0.2;
  }
  .business_option_form {
    width: 800px;
    max-width: 100%;
  }
  .business_option_form img {
    max-width: 100%;
    width: auto !important;
    max-height: 400px;
    cursor: pointer;
    display: block;
    margin: 0 auto;
  }
  .business_ad_form {
    display: flex;
    align-items: center;
  }
  .marketplace_cabinet_container {
    overflow-x: hidden;
  }
  .marketplace_cabinet_container .empty_block {
    padding: 50px;
    color: grey;
    font-weight: 700;
    font-size: 20px;
  }
  .marketplace_cabinet_container button {
    margin: 0 5px !important;
  }
  .marketplace_cabinet_container button:first-child {
    margin-left: 0 !important;
  }
  .marketplace_cabinet_container .customer_history {
    width: 30px;
    height: 30px;
    background: url(history_btn.65d43808.png) no-repeat 0 0;
    background-size: 90px;
  }
  .marketplace_cabinet_container .customer_history:hover {
    background-position: -30px 0;
  }
  .marketplace_cabinet_container .customer_history:active {
    background-position: -60px 0;
  }
  .marketplace_cabinet_container .edit_button {
    width: 30px;
    height: 30px;
    background: url(edit_btn.b0abc2b9.png) no-repeat 0 0;
    background-size: 90px;
  }
  .marketplace_cabinet_container .edit_button:hover {
    background-position: -30px 0;
  }
  .marketplace_cabinet_container .edit_button:active {
    background-position: -60px 0;
  }
  .marketplace_cabinet_container button.fa_element {
    border-radius: 5px;
  }
  .marketplace_cabinet_container button.fa_element i {
    width: 30px;
    height: 30px;
    line-height: 30px;
  }
  .marketplace_cabinet_container button.fa_element .fa-check {
    color: green;
  }
  .marketplace_cabinet_container button.fa_element .fa-ban {
    color: #f52a4f;
  }
  .marketplace_cabinet_container button.fa_element .fa-eye {
    color: #00f;
  }
  .marketplace_cabinet_container button.fa_element:hover {
    background-color: #c2c2c2;
  }
  .marketplace_cabinet_container .delete_button {
    width: 30px;
    height: 30px;
    background: url(delete_btn.1284e414.png) no-repeat 0 0;
    background-size: 90px;
    margin-left: 4px;
  }
  .marketplace_cabinet_container .delete_button:hover {
    background-position: -30px 0;
  }
  .marketplace_cabinet_container .delete_button:active {
    background-position: -60px 0;
  }
  .marketplace_cabinet_container #cabinet_body {
    overflow-x: auto;
    margin-left: 260px;
    padding-top: 64px;
    height: 100%;
    overflow-y: scroll;
  }
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.deals_confirmed
    .col_customer,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.deals_extra
    .col_customer,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.deals_extra
    .col_debt,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.deals_extra
    .deals_filter,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.deals_pending
    .col_customer,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.deals_pending
    .col_debt,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.deals_pending
    .deals_filter,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.sales_confirmed
    .col_business,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.sales_extra
    .col_business,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.sales_extra
    .col_debt,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.sales_extra
    .deals_filter,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.sales_pending
    .col_business,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.sales_pending
    .col_debt,
  .marketplace_cabinet_container
    #cabinet_body
    .loans_partial.sales_pending
    .deals_filter {
    display: none !important;
  }
  .marketplace_cabinet_container #cabinet_body .admin_categories .row {
    padding: 10px;
  }
  .marketplace_cabinet_container
    #cabinet_body
    .admin_categories
    .row:nth-child(odd) {
    background-color: #fafafa;
  }
  .marketplace_cabinet_container
    #cabinet_body
    .admin_categories
    .row:nth-child(2n) {
    background-color: #f5f5f5;
  }
  .marketplace_cabinet_container #cabinet_body .admin_categories .row .col {
    display: flex;
    align-items: center;
  }
  .marketplace_cabinet_container
    #cabinet_body
    .admin_businesses
    .buttons
    button {
    margin: 20px 0 20px 35px !important;
  }
  .marketplace_cabinet_container
    #cabinet_body
    .admin_businesses
    .col.col_image
    .wait_image_loader {
    width: calc(100% - 35px);
  }
  .marketplace_cabinet_container .form_header {
    position: fixed;
    z-index: 2;
    width: calc(100% - 260px);
    top: 0;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12);
    font-size: 16px;
    height: 64px;
    padding: 0 40px;
    border-radius: 4px 4px 0 0;
    background-color: #fcfcfc;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .marketplace_cabinet_container .form_header .lib-btn {
    margin-bottom: 0;
  }
  .marketplace_cabinet_container .form_header i {
    margin-right: 10px;
  }
  .marketplace_cabinet_container .menu {
    position: fixed;
    z-index: 3;
    width: 260px;
    height: 100%;
    top: 0;
    background-color: #2a2a2a;
    display: block;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12);
    max-height: 100%;
    overflow: auto;
  }
  .marketplace_cabinet_container .menu .menu_body {
    margin-top: 84px;
  }
  .marketplace_cabinet_container .menu .reload_box {
    display: block;
    width: 220px;
    text-align: center;
    padding: 10px 0;
    border-top: 1px solid grey;
    margin: 0 auto;
  }
  .marketplace_cabinet_container .menu .reload_box .loading_box {
    margin: 5px auto;
  }
  .marketplace_cabinet_container .menu .hide_mobile_menu_button {
    position: fixed;
    left: 260px;
    top: 0;
    display: none;
    cursor: pointer;
    color: #fff;
    background-color: #2a2a2a;
    padding: 10px;
  }
  .marketplace_cabinet_container .menu .mobile_menu_button {
    position: fixed;
    left: 18px;
    top: 15px;
    display: none;
    cursor: pointer;
  }
  .marketplace_cabinet_container .menu .logo {
    display: block;
    background-color: #333;
    height: 64px;
    color: #fff;
    border-bottom: 1px solid #f52a4f;
    line-height: 64px;
    font-size: 26px;
    font-weight: 600;
    padding-left: 16px;
    cursor: pointer;
    position: fixed;
    width: 260px;
  }
  .marketplace_cabinet_container .menu .menu_button_label {
    width: 20px;
    height: 20px;
    line-height: 20px;
    border-radius: 20px;
    color: #fff;
    text-align: center;
    font-weight: 700;
    display: inline-block;
    margin-left: 10px;
    font-size: 12px;
  }
  .marketplace_cabinet_container .filter {
    display: flex;
    flex-grow: 1;
    align-items: center;
  }
  .marketplace_cabinet_container .filter .customers_filter input {
    background: #f2f2f2;
    border: none;
    width: 100%;
    padding: 3px;
  }
  .marketplace_cabinet_container
    .filter
    .deals_filter
    [type="checkbox"]:checked,
  .marketplace_cabinet_container
    .filter
    .deals_filter
    [type="checkbox"]:not(:checked) {
    display: none;
  }
  .marketplace_cabinet_container .filter .deals_filter label {
    padding: 5px;
    background-color: #fff;
    cursor: pointer;
    border-radius: 4px;
    margin-right: 5px;
  }
  .marketplace_cabinet_container
    .filter
    .deals_filter
    [type="checkbox"]:checked
    + label {
    background: #313234;
    color: #ffc837;
  }
  .marketplace_cabinet_container #customer_history .block_header,
  .marketplace_cabinet_container .customers_filter,
  .marketplace_cabinet_container .deals_filter {
    display: flex;
    padding: 10px 5px;
    width: 100%;
    top: 40px;
    z-index: 2;
    height: 40px;
    align-items: center;
  }
  .marketplace_cabinet_container #marketplaceCustomerFilter {
    margin-right: 20px;
  }
  .marketplace_cabinet_container #marketplaceCustomerFilter input {
    height: 51px;
    line-height: 51px;
    padding: 0 20px;
    outline: none;
    font-size: 15px;
    color: grey;
    max-width: 100%;
    width: 100%;
    box-sizing: border-box;
    display: block;
    border: 1px solid #dbdbdb;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.06);
    font-weight: 500;
    opacity: 1;
    border-radius: 3px;
  }
  .marketplace_cabinet_container
    #marketplaceCustomerLoans.business_customers
    #customers {
    flex-grow: 1;
  }
  .marketplace_cabinet_container
    #marketplaceCustomerLoans.business_customers
    #customers:nth-child(2) {
    border-left: 2px solid grey;
  }
  #marketplaceCustomerLoans,
  #marketplaceCustomerLoans #businesses,
  #marketplaceCustomerLoans #customer_history,
  #marketplaceCustomerLoans #customers,
  #marketplaceCustomerLoans #deals,
  #marketplaceCustomerLoans #loan_form {
    height: 100%;
  }
  #marketplaceCustomerLoans #businesses .table_title,
  #marketplaceCustomerLoans #customer_history .table_title,
  #marketplaceCustomerLoans #customers .table_title,
  #marketplaceCustomerLoans #deals .table_title,
  #marketplaceCustomerLoans #loan_form .table_title {
    padding: 10px 40px;
    border-bottom: 1px solid #e4e4e4;
  }
  #marketplaceCustomerLoans #businesses #deal_table_body,
  #marketplaceCustomerLoans #customer_history #deal_table_body,
  #marketplaceCustomerLoans #customers #deal_table_body,
  #marketplaceCustomerLoans #deals #deal_table_body,
  #marketplaceCustomerLoans #loan_form #deal_table_body {
    max-height: calc(100% - 37px);
    overflow-x: hidden;
    justify-content: space-between;
    overflow-y: auto;
    min-width: fit-content;
    border-top: 2px solid grey;
  }
  #marketplaceCustomerLoans
    #businesses
    #deal_table_body
    ::-webkit-scrollbar-track,
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    ::-webkit-scrollbar-track,
  #marketplaceCustomerLoans
    #customers
    #deal_table_body
    ::-webkit-scrollbar-track,
  #marketplaceCustomerLoans #deals #deal_table_body ::-webkit-scrollbar-track,
  #marketplaceCustomerLoans
    #loan_form
    #deal_table_body
    ::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }
  #marketplaceCustomerLoans #businesses .row,
  #marketplaceCustomerLoans #customer_history .row,
  #marketplaceCustomerLoans #customers .row,
  #marketplaceCustomerLoans #deals .row,
  #marketplaceCustomerLoans #loan_form .row {
    cursor: pointer;
  }
  #marketplaceCustomerLoans #businesses .head_row,
  #marketplaceCustomerLoans #customer_history .head_row,
  #marketplaceCustomerLoans #customers .head_row,
  #marketplaceCustomerLoans #deals .head_row,
  #marketplaceCustomerLoans #loan_form .head_row {
    background-color: #fff;
  }
  #marketplaceCustomerLoans #businesses .head_row .sorter,
  #marketplaceCustomerLoans #customer_history .head_row .sorter,
  #marketplaceCustomerLoans #customers .head_row .sorter,
  #marketplaceCustomerLoans #deals .head_row .sorter,
  #marketplaceCustomerLoans #loan_form .head_row .sorter {
    display: flex;
    flex-direction: column;
    padding: 0;
    margin-right: 10px;
    cursor: pointer;
  }
  #marketplaceCustomerLoans #businesses .head_row .sorter div,
  #marketplaceCustomerLoans #customer_history .head_row .sorter div,
  #marketplaceCustomerLoans #customers .head_row .sorter div,
  #marketplaceCustomerLoans #deals .head_row .sorter div,
  #marketplaceCustomerLoans #loan_form .head_row .sorter div {
    border: none;
    padding: 0;
  }
  #marketplaceCustomerLoans #businesses .head_row,
  #marketplaceCustomerLoans #businesses .row,
  #marketplaceCustomerLoans #customer_history .head_row,
  #marketplaceCustomerLoans #customer_history .row,
  #marketplaceCustomerLoans #customers .head_row,
  #marketplaceCustomerLoans #customers .row,
  #marketplaceCustomerLoans #deals .head_row,
  #marketplaceCustomerLoans #deals .row,
  #marketplaceCustomerLoans #loan_form .head_row,
  #marketplaceCustomerLoans #loan_form .row {
    display: flex;
    justify-content: flex-start;
    font-size: 0;
    padding: 0 35px;
  }
  #marketplaceCustomerLoans #businesses .head_row div,
  #marketplaceCustomerLoans #businesses .row div,
  #marketplaceCustomerLoans #customer_history .head_row div,
  #marketplaceCustomerLoans #customer_history .row div,
  #marketplaceCustomerLoans #customers .head_row div,
  #marketplaceCustomerLoans #customers .row div,
  #marketplaceCustomerLoans #deals .head_row div,
  #marketplaceCustomerLoans #deals .row div,
  #marketplaceCustomerLoans #loan_form .head_row div,
  #marketplaceCustomerLoans #loan_form .row div {
    padding: 10px 5px;
    text-align: left;
    border-right: 1px solid hsla(0, 0%, 70.6%, 0.4);
    display: inline-block;
    vertical-align: top;
    font-size: 14px;
  }
  #marketplaceCustomerLoans #businesses .head_row div:last-child,
  #marketplaceCustomerLoans #businesses .row div:last-child,
  #marketplaceCustomerLoans #customer_history .head_row div:last-child,
  #marketplaceCustomerLoans #customer_history .row div:last-child,
  #marketplaceCustomerLoans #customers .head_row div:last-child,
  #marketplaceCustomerLoans #customers .row div:last-child,
  #marketplaceCustomerLoans #deals .head_row div:last-child,
  #marketplaceCustomerLoans #deals .row div:last-child,
  #marketplaceCustomerLoans #loan_form .head_row div:last-child,
  #marketplaceCustomerLoans #loan_form .row div:last-child {
    border-right: none;
  }
  #marketplaceCustomerLoans #businesses .head_row .col_actions,
  #marketplaceCustomerLoans #businesses .row .col_actions,
  #marketplaceCustomerLoans #customer_history .head_row .col_actions,
  #marketplaceCustomerLoans #customer_history .row .col_actions,
  #marketplaceCustomerLoans #customers .head_row .col_actions,
  #marketplaceCustomerLoans #customers .row .col_actions,
  #marketplaceCustomerLoans #deals .head_row .col_actions,
  #marketplaceCustomerLoans #deals .row .col_actions,
  #marketplaceCustomerLoans #loan_form .head_row .col_actions,
  #marketplaceCustomerLoans #loan_form .row .col_actions {
    border-right: none;
  }
  #marketplaceCustomerLoans #businesses .head_row .col_actions button,
  #marketplaceCustomerLoans #businesses .row .col_actions button,
  #marketplaceCustomerLoans #customer_history .head_row .col_actions button,
  #marketplaceCustomerLoans #customer_history .row .col_actions button,
  #marketplaceCustomerLoans #customers .head_row .col_actions button,
  #marketplaceCustomerLoans #customers .row .col_actions button,
  #marketplaceCustomerLoans #deals .head_row .col_actions button,
  #marketplaceCustomerLoans #deals .row .col_actions button,
  #marketplaceCustomerLoans #loan_form .head_row .col_actions button,
  #marketplaceCustomerLoans #loan_form .row .col_actions button {
    margin: 5px !important;
    padding: 7px;
    font-size: 14px;
  }
  #marketplaceCustomerLoans #businesses .row:nth-child(odd),
  #marketplaceCustomerLoans #customer_history .row:nth-child(odd),
  #marketplaceCustomerLoans #customers .row:nth-child(odd),
  #marketplaceCustomerLoans #deals .row:nth-child(odd),
  #marketplaceCustomerLoans #loan_form .row:nth-child(odd) {
    background-color: rgba(0, 0, 0, 0.035);
  }
  #marketplaceCustomerLoans #businesses .row:hover,
  #marketplaceCustomerLoans #customer_history .row:hover,
  #marketplaceCustomerLoans #customers .row:hover,
  #marketplaceCustomerLoans #deals .row:hover,
  #marketplaceCustomerLoans #loan_form .row:hover {
    background-color: rgba(0, 0, 0, 0.05);
  }
  #marketplaceCustomerLoans #businesses .head_row,
  #marketplaceCustomerLoans #customer_history .head_row,
  #marketplaceCustomerLoans #customers .head_row,
  #marketplaceCustomerLoans #deals .head_row,
  #marketplaceCustomerLoans #loan_form .head_row {
    font-weight: 700;
  }
  #marketplaceCustomerLoans #businesses #deal_table_body {
    max-height: calc(100% - 37px);
  }
  #marketplaceCustomerLoans #businesses #deal_table_body,
  #marketplaceCustomerLoans #businesses .row {
    cursor: default;
  }
  #marketplaceCustomerLoans #businesses #deal_table_body .col_actions,
  #marketplaceCustomerLoans #businesses .row .col_actions {
    display: flex;
    align-items: center;
    border-right: none;
  }
  #marketplaceCustomerLoans #businesses #deal_table_body .col_actions button,
  #marketplaceCustomerLoans #businesses .row .col_actions button {
    margin: 0;
  }
  #marketplaceCustomerLoans #businesses #deal_table_body .col_actions .lib-btn,
  #marketplaceCustomerLoans #businesses .row .col_actions .lib-btn {
    margin: 0 5px 0 0;
    padding: 6px 25px;
  }
  #marketplaceCustomerLoans #businesses #deal_table_body .col,
  #marketplaceCustomerLoans #businesses .head_row .col {
    flex-grow: 1;
    flex-basis: 0;
    display: flex;
    align-items: center;
  }
  #marketplaceCustomerLoans #businesses .buttons {
    display: flex;
    align-items: center;
  }
  #marketplaceCustomerLoans #businesses .buttons button {
    margin-left: 5px;
  }
  #marketplaceCustomerLoans #customer_history,
  #marketplaceCustomerLoans #customers,
  #marketplaceCustomerLoans #deals,
  #marketplaceCustomerLoans #loan_form {
    flex-grow: 1;
    flex-basis: 0;
  }
  #marketplaceCustomerLoans #customer_history #deal_table_body,
  #marketplaceCustomerLoans #customer_history .row,
  #marketplaceCustomerLoans #customers #deal_table_body,
  #marketplaceCustomerLoans #customers .row,
  #marketplaceCustomerLoans #deals #deal_table_body,
  #marketplaceCustomerLoans #deals .row,
  #marketplaceCustomerLoans #loan_form #deal_table_body,
  #marketplaceCustomerLoans #loan_form .row {
    cursor: default;
  }
  #marketplaceCustomerLoans #customer_history #deal_table_body .col,
  #marketplaceCustomerLoans #customer_history .head_row .col,
  #marketplaceCustomerLoans #customers #deal_table_body .col,
  #marketplaceCustomerLoans #customers .head_row .col,
  #marketplaceCustomerLoans #deals #deal_table_body .col,
  #marketplaceCustomerLoans #deals .head_row .col,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col,
  #marketplaceCustomerLoans #loan_form .head_row .col {
    display: flex;
    align-items: center;
    flex-grow: 1;
    flex-basis: 0;
    flex-flow: row wrap;
    box-sizing: border-box;
  }
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_email,
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_memo,
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_telegram,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_email,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_memo,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_telegram,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_email,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_memo,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_telegram,
  #marketplaceCustomerLoans #customers .head_row .col.col_email,
  #marketplaceCustomerLoans #customers .head_row .col.col_memo,
  #marketplaceCustomerLoans #customers .head_row .col.col_telegram,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_email,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_memo,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_telegram,
  #marketplaceCustomerLoans #deals .head_row .col.col_email,
  #marketplaceCustomerLoans #deals .head_row .col.col_memo,
  #marketplaceCustomerLoans #deals .head_row .col.col_telegram,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_email,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_memo,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_telegram,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_email,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_memo,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_telegram {
    min-width: 250px;
  }
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_customer,
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_email,
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_telegram,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_customer,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_email,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_telegram,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_customer,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_email,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_telegram,
  #marketplaceCustomerLoans #customers .head_row .col.col_customer,
  #marketplaceCustomerLoans #customers .head_row .col.col_email,
  #marketplaceCustomerLoans #customers .head_row .col.col_telegram,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_customer,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_email,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_telegram,
  #marketplaceCustomerLoans #deals .head_row .col.col_customer,
  #marketplaceCustomerLoans #deals .head_row .col.col_email,
  #marketplaceCustomerLoans #deals .head_row .col.col_telegram,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_customer,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_email,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_telegram,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_customer,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_email,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_telegram {
    user-select: all;
    cursor: text;
  }
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_debt,
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_quantity,
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_type,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_debt,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_quantity,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_type,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_debt,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_quantity,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_type,
  #marketplaceCustomerLoans #customers .head_row .col.col_debt,
  #marketplaceCustomerLoans #customers .head_row .col.col_quantity,
  #marketplaceCustomerLoans #customers .head_row .col.col_type,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_debt,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_quantity,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_type,
  #marketplaceCustomerLoans #deals .head_row .col.col_debt,
  #marketplaceCustomerLoans #deals .head_row .col.col_quantity,
  #marketplaceCustomerLoans #deals .head_row .col.col_type,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_debt,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_quantity,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_type,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_debt,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_quantity,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_type {
    min-width: 100px;
  }
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_datetime,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_datetime,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_datetime,
  #marketplaceCustomerLoans #customers .head_row .col.col_datetime,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_datetime,
  #marketplaceCustomerLoans #deals .head_row .col.col_datetime,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_datetime,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_datetime {
    min-width: 124px;
  }
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_agent,
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_agent1,
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_business,
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_customer,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_agent,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_agent1,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_business,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_customer,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_agent,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_agent1,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_business,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_customer,
  #marketplaceCustomerLoans #customers .head_row .col.col_agent,
  #marketplaceCustomerLoans #customers .head_row .col.col_agent1,
  #marketplaceCustomerLoans #customers .head_row .col.col_business,
  #marketplaceCustomerLoans #customers .head_row .col.col_customer,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_agent,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_agent1,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_business,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_customer,
  #marketplaceCustomerLoans #deals .head_row .col.col_agent,
  #marketplaceCustomerLoans #deals .head_row .col.col_agent1,
  #marketplaceCustomerLoans #deals .head_row .col.col_business,
  #marketplaceCustomerLoans #deals .head_row .col.col_customer,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_agent,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_agent1,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_business,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_customer,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_agent,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_agent1,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_business,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_customer {
    min-width: 200px;
  }
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_actions,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_actions,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_actions,
  #marketplaceCustomerLoans #customers .head_row .col.col_actions,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_actions,
  #marketplaceCustomerLoans #deals .head_row .col.col_actions,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_actions,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_actions {
    min-width: 166px;
  }
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_state,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_state,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_state,
  #marketplaceCustomerLoans #customers .head_row .col.col_state,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_state,
  #marketplaceCustomerLoans #deals .head_row .col.col_state,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_state,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_state {
    min-width: 80px;
  }
  #marketplaceCustomerLoans #customer_history #deal_table_body .col.col_image,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_image,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_image,
  #marketplaceCustomerLoans #customers .head_row .col.col_image,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_image,
  #marketplaceCustomerLoans #deals .head_row .col.col_image,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_image,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_image {
    min-width: 100px;
    max-width: 150px;
  }
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_image
    img,
  #marketplaceCustomerLoans #customer_history .head_row .col.col_image img,
  #marketplaceCustomerLoans #customers #deal_table_body .col.col_image img,
  #marketplaceCustomerLoans #customers .head_row .col.col_image img,
  #marketplaceCustomerLoans #deals #deal_table_body .col.col_image img,
  #marketplaceCustomerLoans #deals .head_row .col.col_image img,
  #marketplaceCustomerLoans #loan_form #deal_table_body .col.col_image img,
  #marketplaceCustomerLoans #loan_form .head_row .col.col_image img {
    width: 100%;
  }
  #marketplaceCustomerLoans
    #customer_history
    #deal_table_body
    .col.col_image.wait_image_loader,
  #marketplaceCustomerLoans
    #customer_history
    .head_row
    .col.col_image.wait_image_loader,
  #marketplaceCustomerLoans
    #customers
    #deal_table_body
    .col.col_image.wait_image_loader,
  #marketplaceCustomerLoans
    #customers
    .head_row
    .col.col_image.wait_image_loader,
  #marketplaceCustomerLoans
    #deals
    #deal_table_body
    .col.col_image.wait_image_loader,
  #marketplaceCustomerLoans #deals .head_row .col.col_image.wait_image_loader,
  #marketplaceCustomerLoans
    #loan_form
    #deal_table_body
    .col.col_image.wait_image_loader,
  #marketplaceCustomerLoans
    #loan_form
    .head_row
    .col.col_image.wait_image_loader {
    height: 78px;
  }
  #marketplaceCustomerLoans #customer_history .info,
  #marketplaceCustomerLoans #customers .info,
  #marketplaceCustomerLoans #deals .info,
  #marketplaceCustomerLoans #loan_form .info {
    font-size: 12px;
    color: grey;
    margin-right: 5px;
  }
  #marketplaceCustomerLoans #customer_history .block_header,
  #marketplaceCustomerLoans #customers .block_header,
  #marketplaceCustomerLoans #deals .block_header,
  #marketplaceCustomerLoans #loan_form .block_header {
    justify-content: space-around;
    position: absolute;
    top: 11px;
    flex-direction: row-reverse;
    width: 50%;
  }
  #marketplaceCustomerLoans #customer_history .block_header .business,
  #marketplaceCustomerLoans
    #customer_history
    .block_header
    .lib-btn.lib-btn-contract,
  #marketplaceCustomerLoans #customers .block_header .business,
  #marketplaceCustomerLoans #customers .block_header .lib-btn.lib-btn-contract,
  #marketplaceCustomerLoans #deals .block_header .business,
  #marketplaceCustomerLoans #deals .block_header .lib-btn.lib-btn-contract,
  #marketplaceCustomerLoans #loan_form .block_header .business,
  #marketplaceCustomerLoans #loan_form .block_header .lib-btn.lib-btn-contract {
    display: none;
  }
  #marketplaceCustomerLoans #customer_history .block_header .lib-btn,
  #marketplaceCustomerLoans #customers .block_header .lib-btn,
  #marketplaceCustomerLoans #deals .block_header .lib-btn,
  #marketplaceCustomerLoans #loan_form .block_header .lib-btn {
    margin: 0;
  }
  #marketplaceCustomerLoans #customer_history .block_header .client,
  #marketplaceCustomerLoans #customers .block_header .client,
  #marketplaceCustomerLoans #deals .block_header .client,
  #marketplaceCustomerLoans #loan_form .block_header .client {
    color: #f52a4f;
    font-weight: 700;
  }
  #marketplaceCustomerLoans #customer_history .datetime,
  #marketplaceCustomerLoans #customers .datetime,
  #marketplaceCustomerLoans #deals .datetime,
  #marketplaceCustomerLoans #loan_form .datetime {
    font-size: 12px;
    color: grey;
  }
  .icon-btn {
    cursor: pointer;
    color: #333;
  }
  .icon-btn i {
    margin-right: 5px;
  }
  .marketplace_landing_container {
    margin-top: 64px;
    overflow: auto;
    position: relative;
    /* background: #f7f7f7; */
  }
  .marketplace_landing_container .language_container .current_lang {
    color: #f52a4f;
  }
  .marketplace_landing_container .language_container .dropdown {
    color: #000;
    background: #e8e8e8;
  }
  .marketplace_landing_container .lib-btn {
    margin: 0;
  }
  .marketplace_landing_container .fl {
    display: flex;
  }
  .marketplace_landing_container .fl.va-c {
    align-items: center;
  }
  .marketplace_landing_container .sl {
    font-family: simple-line-icons !important;
    speak: none;
    font-style: normal;
    font-weight: 400;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
  .marketplace_landing_container header {
    z-index: 2;
    width: 100%;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12);
    font-size: 16px;
    display: flex;
    align-items: center;
    height: 64px;
    position: fixed;
    top: 0;
    background-color: #fff;
  }
  .marketplace_landing_container header .header_logo {
    cursor: pointer;
    color: #f52a4f;
    text-transform: uppercase;
    font-size: 24px;
    background: linear-gradient(90deg, #f52a4f, #33001b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  @media (max-width: 900px) {
    .marketplace_landing_container header .header_logo {
      font-size: 14px;
    }
  }
  .marketplace_landing_container header #header_body {
    width: 100%;
    margin: 0 20%;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .marketplace_landing_container header #header_body .icon-btn {
    border-radius: 10px;
    padding: 8px 12px;
    transition: transform 0.3s;
    white-space: nowrap;
    text-transform: lowercase;
  }
  @media (max-width: 900px) {
    .marketplace_landing_container header #header_body .icon-btn {
      padding: 8px;
    }
    .marketplace_landing_container
      header
      #header_body
      .icon-btn
      span:not(.notifications_count) {
      display: none;
    }
  }
  .marketplace_landing_container header #header_body .icon-btn:hover {
    background: #f5f5f5;
  }
  .marketplace_landing_container header #header_body .icon-btn:hover i {
    color: #f52a4f;
  }
  .marketplace_landing_container header #header_body .sign-in {
    position: relative;
    color: #333;
    display: inline-block;
    vertical-align: top;
  }
  .marketplace_landing_container header #header_body .sign-in i {
    padding-right: 4px;
    font-size: 15px;
  }
  .marketplace_landing_container header #header_body .icon-btn.notifications {
    margin-left: 10px;
    display: flex;
    align-items: center;
    position: relative;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
  .marketplace_landing_container
    header
    #header_body
    .icon-btn.notifications
    .notifications_count {
    padding: 2px 6px;
    background-color: red;
    border-radius: 16px;
    color: #fff;
    font-size: 12px;
  }
  .marketplace_landing_container
    header
    #header_body
    .icon-btn.notifications
    #notifications_body {
    display: none;
    position: absolute;
    top: 34px;
    background: #e8e8e8;
    width: 270px;
    right: 0;
    padding: 10px;
    color: #101010;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
    border-top-left-radius: 4px;
  }
  .marketplace_landing_container
    header
    #header_body
    .icon-btn.notifications
    #notifications_body
    .row {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    text-transform: none;
  }
  .marketplace_landing_container
    header
    #header_body
    .icon-btn.notifications
    #notifications_body
    .row:hover {
    background-color: #e0e0e0;
  }
  .marketplace_landing_container
    header
    #header_body
    .icon-btn.notifications:hover
    #notifications_body {
    display: block;
  }
  .marketplace_landing_container #banners {
    margin: 65px 20% 0;
  }
  .marketplace_landing_container .business_banner {
    height: 200px;
    display: flex;
    cursor: pointer;
    margin-bottom: 48px;
    width: 100%;
    border-radius: 4px;
    overflow: hidden;
    border: 1px solid #efefef;
    background: #fff;
  }
  .marketplace_landing_container .business_banner .info {
    align-self: center;
    padding: 10px 20px;
    height: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    position: relative;
  }
  .marketplace_landing_container .business_banner .info h3 {
    color: #333;
    font-size: 24px;
    font-weight: 600;
    line-height: 28px;
    margin-bottom: 10px;
  }
  .marketplace_landing_container .business_banner .info h4 {
    color: grey;
    font-size: 16px;
    font-weight: 300;
    line-height: 1.4;
    overflow: auto;
  }
  @media (max-width: 900px) {
    .marketplace_landing_container .business_banner .info h4 {
      font-size: 14px;
    }
  }
  .marketplace_landing_container .business_banner .info:before {
    content: "";
    width: 100%;
    height: 37px;
    position: absolute;
    left: 0;
    bottom: 0;
    background: linear-gradient(hsla(0, 0%, 100%, 0.31) -10px, #fff);
  }
  .marketplace_landing_container .business_banner .image {
    position: relative;
    overflow: hidden;
    display: table;
    height: 200px;
  }
  .marketplace_landing_container .business_banner .image img {
    height: 200px;
    transition: all 1s;
    will-change: auto;
  }
  .marketplace_landing_container .business_banner .image.wait_image_loader {
    width: 356px;
  }
  .marketplace_landing_container .business_banner .image .category_label {
    position: absolute;
    bottom: 20px;
    left: 20px;
    background: #66676b;
    z-index: 10;
    line-height: 14px;
    padding: 7px 16px;
    margin-right: 20px;
    text-align: center;
    text-transform: uppercase;
    font-size: 9px;
    letter-spacing: 2.5px;
    border-radius: 50px;
    color: #fff;
  }
  .marketplace_landing_container .business_banner .image .category_label i {
    margin-right: 10px;
  }
  .marketplace_landing_container .business_banner:hover {
    box-shadow: 2px 2px 29px 0 rgba(0, 0, 0, 0.26);
  }
  .marketplace_landing_container .business_banner:hover img {
    transform: scale(1.1);
  }
  .marketplace_landing_container .footer {
    color: #707070;
    border-top: 1px solid rgba(0, 0, 0, 0.09);
    margin-top: 60px;
    text-align: center;
    padding: 40px 0;
    display: inline-block;
    width: 100%;
  }
  .marketplace_landing_container .footer .contacts {
    margin-top: 10px;
  }
  .marketplace_landing_container .footer .contacts a {
    color: #707070;
    padding: 0 5px;
    text-decoration: none;
  }
  .marketplace_landing_container #search_panel {
    position: absolute;
    width: 60%;
    left: 20%;
    display: flex;
    justify-content: space-between;
    border-radius: 50px;
    background-color: #fff;
    box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.12);
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 10px 30px;
    margin-top: -100px;
  }
  .marketplace_landing_container #search_panel div {
    align-self: center;
    display: flex;
    align-items: center;
  }
  .marketplace_landing_container #search_panel input,
  .marketplace_landing_container #search_panel select {
    font-size: 16px;
    border: none;
    background: #fff;
    margin: 0;
    padding: 0;
    height: 44px;
    line-height: 44px;
    box-shadow: none;
    outline: none;
    color: #888;
    width: 100%;
  }
  .marketplace_landing_container #search_panel button:last-child {
    margin-left: 5px;
  }
  .marketplace_landing_container .delete_button {
    width: 30px;
    height: 30px;
    background: url(delete_btn.1284e414.png) no-repeat 0 0;
    background-size: 90px;
    margin-left: 4px;
  }
  .marketplace_landing_container .delete_button:hover {
    background-position: -30px 0;
  }
  .marketplace_landing_container .delete_button:active {
    background-position: -60px 0;
  }
  .marketplace_landing_container .page_not_found_body {
    margin: 60px auto 0;
    text-align: center;
  }
  .marketplace_landing_container .page_not_found_body h1 {
    font-size: 100px;
    color: grey;
    margin-bottom: 20px;
  }
  .marketplace_landing_container .page_not_found_body h2 {
    font-size: 60px;
    color: grey;
  }
  .win-base {
    position: fixed;
    z-index: 20;
    left: 50%;
    transform: translate(-50%, -50%);
    top: 50%;
    background-color: #fff;
    border: 1px solid #e6e6e6;
    box-shadow: 0 0 12px 0 rgba(0, 0, 0, 0.12);
    max-height: 90%;
    max-width: 90%;
    overflow: auto;
    padding: 30px;
    border-radius: 10px;
  }
  .win-base .win-btn-close {
    position: absolute;
    right: 16px;
    top: 12px;
    width: 20px;
    height: 20px;
    opacity: 0.3;
    background: none;
    z-index: 2;
  }
  .win-base .win-btn-close:hover {
    opacity: 1;
  }
  .win-base .win-btn-close:after,
  .win-base .win-btn-close:before {
    top: 0;
    position: absolute;
    left: 15px;
    content: " ";
    height: 20px;
    width: 2px;
    background-color: #333;
  }
  .win-base .win-btn-close:before {
    transform: rotate(45deg);
  }
  .win-base .win-btn-close:after {
    transform: rotate(-45deg);
  }
  .win-base .toolbar__button {
    background-color: transparent;
    border-width: 0;
    color: #fff;
    cursor: pointer;
    display: block;
    float: left;
    font-size: 0.875rem;
    height: 2rem;
    text-align: center;
    width: 2rem;
  }
  .win-base .toolbar__button:hover {
    background-color: #0074d9;
    color: #fff;
  }
  .win-base .toolbar {
    background-color: rgba(0, 0, 0, 0.5);
    bottom: 1rem;
    color: #fff;
    height: 2rem;
    width: 16rem;
    margin: 10px auto;
  }
  .win-base .modify_image_container img {
    max-width: 800px;
    max-height: 800px;
  }
  .win-base .no_image_placeholder {
    height: 300px;
  }
  .win-base .no_image_placeholder:before {
    height: 300px;
    line-height: 300px;
  }
  .business_view .info {
    display: flex;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 2px solid grey;
  }
  .business_view .info div {
    flex-grow: 1;
    flex-basis: 0;
  }
  .business_view .info .description_box {
    padding-left: 20px;
  }
  .business_view .info .image_box img {
    width: 100%;
  }
  .dashboard-nav ul {
    list-style: none;
    padding: 0;
    margin: 15px 0 0;
  }
  .dashboard-nav ul li a {
    color: #eee;
    display: block;
    border-left: 3px solid transparent;
    transition: 0.3s;
    line-height: 24px;
    font-size: 15px;
    outline: none;
    text-decoration: none;
    padding: 11px 16px;
    cursor: pointer;
    text-transform: capitalize;
  }
  .dashboard-nav ul li a i {
    width: 30px;
  }
  .dashboard-nav ul li a.active,
  .dashboard-nav ul li a:hover {
    color: #fff;
    border-color: #66676b;
    background-color: hsla(0, 0%, 100%, 0.05);
  }
  .dashboard-nav ul li a.active,
  .dashboard-nav ul li a:active {
    border-color: #f52a4f;
  }
  .dashboard-nav ul:before {
    content: attr(data-submenu-title);
    padding: 0 16px;
    margin-bottom: 5px;
    display: block;
    color: #999;
    text-transform: uppercase;
    font-weight: 300;
    font-size: 12px;
    letter-spacing: 1px;
  }
  .gm-style .gm-style-iw-t:after {
    content: "";
    position: absolute;
    bottom: 0;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    border-left: 20px solid transparent;
    border-right: 20px solid transparent;
    border-top: 20px solid #f52a4f;
    box-shadow: none;
    top: -1px;
  }
  .gm-style-iw-t {
    bottom: 60px !important;
  }
  .gm-style-iw.gm-style-iw-c.my_window {
    border-radius: 0;
    padding: 0;
  }
  .gm-style-iw.gm-style-iw-c.my_window .gm-ui-hover-effect {
    display: none !important;
  }
  .gm-style-iw.gm-style-iw-c.my_window .gm-style-iw-d {
    overflow: auto !important;
  }
  .gm-style-iw.gm-style-iw-c.my_window .infoBox {
    width: 100%;
    max-width: 270px;
    cursor: pointer;
    display: none;
    animation: fadeIn 0.9s;
  }
  .gm-style-iw.gm-style-iw-c.my_window .infoBox.opened {
    display: block;
  }
  .gm-style-iw.gm-style-iw-c.my_window .infoBox .map-box {
    background-color: #f52a4f;
    border-radius: 4px;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.12);
    position: relative;
  }
  .gm-style-iw.gm-style-iw-c.my_window .infoBox .map-box .listing-item-content {
    position: absolute;
    bottom: 20px;
    left: 0;
    padding: 0 10px;
    width: 100%;
    z-index: 50;
    box-sizing: border-box;
    font-family: Raleway, HelveticaNeue, Helvetica Neue, Helvetica, Arial,
      sans-serif;
    text-transform: none;
  }
  .gm-style-iw.gm-style-iw-c.my_window
    .infoBox
    .map-box
    .listing-item-content
    span {
    pointer-events: none;
    font-size: 15px;
    font-weight: 300;
    display: inline-block;
    color: hsla(0, 0%, 100%, 0.7);
  }
  .gm-style-iw.gm-style-iw-c.my_window
    .infoBox
    .map-box
    .listing-item-content
    h3 {
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    margin: 0;
    line-height: 18px;
  }
  .gm-style-iw.gm-style-iw-c.my_window
    .infoBox
    .map-box
    .listing-img-container {
    position: relative;
    height: 100%;
    display: block;
  }
  .gm-style-iw.gm-style-iw-c.my_window
    .infoBox
    .map-box
    .listing-img-container:before {
    content: "";
    position: absolute;
    bottom: 2px;
    height: 100%;
    width: 100%;
    display: block;
    background: linear-gradient(
      0deg,
      rgba(35, 35, 37, 0.85) 0,
      rgba(35, 35, 37, 0.4) 35%,
      rgba(22, 22, 23, 0) 60%,
      transparent
    );
    cursor: pointer;
  }
  .gm-style-iw.gm-style-iw-c.my_window
    .infoBox
    .map-box
    .listing-img-container
    img {
    width: 100%;
    max-width: 270px;
    border-radius: 4px 4px 0 0;
  }
  .gm-style-iw.gm-style-iw-c.my_window
    .infoBox
    .map-box
    .listing-img-container
    .wait_image_loader {
    width: 270px;
    height: 152px;
  }
  .gm-style-iw.gm-style-iw-c.my_window .infoBox .infoBox-close {
    position: absolute;
    top: 10px;
    right: 10px;
    display: inline-block;
    z-index: 999;
    text-align: center;
    line-height: 29px;
    cursor: pointer;
    font-size: 15px;
    font-weight: 500;
    height: 29px;
    width: 29px;
    background-color: #fff;
    color: #333;
    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition: all 0.2s ease-in-out;
    -o-transition: all 0.2s ease-in-out;
    -ms-transition: all 0.2s ease-in-out;
    transition: all 0.2s ease-in-out;
    font-family: FontAwesome;
    border-radius: 50%;
    -webkit-text-stroke: 1px #fff;
  }
  .gm-style-iw.gm-style-iw-c.my_window .infoBox .infoBox-close:hover {
    background-color: #f52a4f;
    -webkit-text-stroke: 1px #f52a4f;
  }
  .marker-card {
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: all 0.4s ease-in-out;
    position: absolute;
    z-index: 1;
  }
  .map-marker-container {
    position: absolute;
    margin-top: 10px;
    transform: translate3d(-50%, -100%, 0);
  }
  .marker-container {
    position: relative;
    margin: 10px auto;
    width: 42px;
    height: 42px;
    z-index: 1;
    border-radius: 50%;
    cursor: pointer;
    top: -5px;
  }
  .map-marker-container.clicked .marker-card,
  .marker-container:hover .marker-card {
    transform: rotateY(180deg) translateY(-4px);
  }
  .face.front {
    background-color: #fff;
    border: 2px solid #f52a4f;
    color: #f52a4f;
    z-index: 100;
  }
  .face {
    position: absolute;
    width: 100%;
    height: 100%;
    backface-visibility: hidden;
    text-align: center;
    border-radius: 50%;
    color: #fff;
    z-index: 100;
  }
  .face i {
    line-height: 38px;
    font-size: 20px;
  }
  .face.back i {
    transform: scaleX(-1);
    line-height: 38px;
    font-size: 18px;
  }
  .face.back {
    transform: rotateY(180deg);
    box-sizing: border-box;
    color: #fff;
    background: #f52a4f;
    border-color: #f52a4f;
  }
  .face.back:after {
    content: "";
    display: block;
    width: 36px;
    height: 36px;
    top: 2px;
    left: 2px;
    border: 1px solid hsla(0, 0%, 100%, 0.65);
    border-radius: 50%;
    position: absolute;
  }
  .marker-arrow {
    width: 0;
    content: "";
    height: 0;
    border-color: #f52a4f transparent transparent;
    border-style: solid;
    border-width: 8px 4px 0;
    top: 40px;
    left: 50%;
    transform: translateX(-50%);
    position: absolute;
    border-radius: 50%;
    z-index: 1;
  }
  .eosmarketplace_loading_page .loading_box,
  .menu_body .loading_box {
    height: 10px;
    border-radius: 5px;
    border: 1px solid grey;
    width: 200px;
    background: linear-gradient(90deg, #f52a4f, #33001b) no-repeat;
    background-size: 0 100%;
    margin: 5px 0;
  }
  .eosmarketplace_loading_page .header_logo {
    cursor: pointer;
    color: #f52a4f;
    text-transform: uppercase;
    font-size: 24px;
    background: linear-gradient(90deg, #f52a4f, #33001b);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
  .business_container {
    color: #707070;
    overflow-x: hidden;
    margin: 0 20%;
    padding: 0 20px;
    background-color: #fff;
    border: 1px solid #ececec;
  }
  .business_container #top {
    display: flex;
  }
  .business_container a {
    color: #f52a4f;
  }
  .business_container a,
  .business_container button {
    outline: none !important;
    text-decoration: none;
  }
  .business_container p {
    font-size: 16px;
    line-height: 24px;
  }
  @media (max-width: 900px) {
    .business_container p {
      font-size: 14px;
    }
  }
  .business_container .clearfix {
    clear: both;
  }
  .business_container #left {
    flex-basis: 0;
    flex-grow: 0.6;
    padding-right: 30px;
    z-index: 0;
  }
  .business_container #right {
    margin-top: 180px;
    flex-basis: 0;
    flex-grow: 0.4;
    z-index: 0;
  }
  .business_container #titlebar {
    position: relative;
    padding-top: 70px;
    margin-bottom: 12px;
  }
  .business_container #tiptip_content,
  .business_container .map-box div,
  .business_container .map-box p,
  .business_container .numerical-rating .rating-counter,
  .business_container body,
  .business_container body .menu-responsive i.menu-trigger:after,
  .business_container button,
  .business_container h1,
  .business_container h2,
  .business_container h3,
  .business_container h4,
  .business_container h5,
  .business_container h6,
  .business_container input[type="button"],
  .business_container input[type="email"],
  .business_container input[type="password"],
  .business_container input[type="submit"],
  .business_container input[type="text"],
  .business_container select,
  .business_container textarea {
    font-family: Raleway, HelveticaNeue, Helvetica Neue, Helvetica, Arial,
      sans-serif;
    text-transform: none;
  }
  .business_container #titlebar.listing-titlebar h1,
  .business_container #titlebar.listing-titlebar h2 {
    font-size: 24px;
    line-height: 28px;
    color: #333;
    display: flex;
  }
  .business_container #titlebar.listing-titlebar div.listing-tag {
    color: #f52a4f;
    padding: 8px 16px;
    line-height: 15px;
    letter-spacing: 2.5px;
    border-radius: 50px;
    text-transform: uppercase;
    background-color: #fff;
    font-size: 10px;
    font-weight: 500;
    position: relative;
    top: -6px;
    margin: 0 0 0 10px;
    border: 1px solid #f52a4f;
  }
  .business_container #titlebar.listing-titlebar span {
    font-size: 14px;
    color: #888;
    margin-top: 4px;
    padding: 0 1px;
    display: inline-block;
  }
  @media (max-width: 900px) {
    .business_container #titlebar.listing-titlebar span {
      display: flex;
      font-size: 12px;
      align-items: center;
    }
  }
  .business_container #titlebar.listing-titlebar span i {
    margin-right: 5px;
  }
  .business_container .margin-top-35 {
    margin-top: 35px !important;
  }
  .business_container .boxed-widget {
    border-radius: 3px;
    padding: 32px 0;
    transform: translateZ(0);
    z-index: 90;
    position: relative;
  }
  .business_container .hosted-by-title {
    padding: 0 70px 18px 0;
    margin: -4px 0 25px;
    display: block;
    border-bottom: 1px solid #e8e8e8;
    position: relative;
  }
  .business_container .hosted-by-title h4 {
    font-size: 18px;
    transition: 0.2s;
    line-height: 22px;
    font-weight: 600;
    margin: 4px 0 7px;
    color: #333;
  }
  .business_container .hosted-by-avatar {
    max-width: 56px;
    overflow: hidden;
    border-radius: 50%;
    position: absolute;
    right: 0;
    top: -8px;
  }
  .business_container .listing-details-sidebar {
    padding: 0;
    list-style: none;
    font-size: 15px;
    margin-bottom: -5px;
    position: relative;
    display: block;
  }
  .business_container .hosted-by-title h4 span {
    display: block;
    font-size: 14px;
    font-weight: 400;
    color: #888;
  }
  .business_container .listing-details-sidebar li {
    display: block;
    padding-left: 26px;
    position: relative;
    margin-bottom: 5px;
    line-height: 24px;
  }
  .business_container .listing-details-sidebar li i {
    position: absolute;
    left: 0;
    top: 5px;
    font-size: 16px;
    color: #888;
  }
  .business_container .listing-nav {
    width: 100%;
    padding: 0;
    list-style: none;
    border-bottom: 1px solid #e0e0e0;
    font-size: 17px;
    font-weight: 400;
    margin: 0 0 35px;
  }
  .business_container .listing-nav li {
    display: inline-block;
    margin-right: 15px;
  }
  .business_container .listing-nav li a {
    display: inline-block;
    border-bottom: 1px solid #e0e0e0;
    position: relative;
    bottom: -1px;
    transition: 0.3s;
    color: #666;
    padding-bottom: 15px;
  }
  .business_container
    .listing-nav-container.cloned
    .listing-nav
    li:first-child
    a.active,
  .business_container
    .listing-nav-container.cloned
    .listing-nav
    li:first-child
    a:hover,
  .business_container .listing-nav li:first-child a,
  .business_container .listing-nav li a.active,
  .business_container .listing-nav li a:hover {
    border-color: #f52a4f;
    color: #f52a4f;
  }
  .business_container .listing-links-container {
    margin: 25px 0 0;
    display: block;
  }
  .business_container .listing-links li {
    display: inline-block;
    list-style: none;
    padding: 0;
    margin: 0;
    float: left;
  }
  .business_container .listing-links li a {
    background: #f2f2f2;
    color: #555;
    font-weight: 500;
    font-size: 13px;
    padding: 7px 14px;
    transition: 0.3s;
    display: inline-block;
    line-height: 17px;
    position: relative;
  }
  .business_container .listing-links.contact-links li a {
    border-left: 1px solid #e0e0e0;
  }
  .business_container .listing-links.contact-links li i {
    margin-right: 5px;
  }
  .business_container .listing-links.contact-links li:first-child a {
    border-left: none;
  }
  .business_container .listing-links {
    list-style: none;
    padding: 0;
    margin: 0 0 10px;
    display: block;
  }
  .business_container .map_view {
    height: 300px;
  }
  .business_container .listing-image img {
    width: 100%;
  }
  .business_container .options .business_option_view {
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-bottom: 20px;
    border: 1px solid #e0e0e0;
  }
  .business_container .options .business_option_view .price_box {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    margin-top: 20px;
  }
  .business_container .options .business_option_view .lib-btn-contract {
    padding: 8px 26px;
  }
  .business_container .options .business_option_view .details {
    flex-grow: 0.6;
    flex-basis: 0;
  }
  .business_container .options .business_option_view .image {
    flex-grow: 0.4;
    flex-basis: 0;
    margin-right: 30px;
    text-align: center;
  }
  .business_container .options .business_option_view .image img {
    max-width: 100%;
  }
  .business_container .options .business_option_view .title {
    font-size: 24px;
    line-height: 28px;
    margin-bottom: 20px;
    font-weight: 600;
    color: #333;
    position: relative;
  }
  .business_container .options .business_option_view .quantity_input {
    width: 50px;
    font-size: 18px;
    text-align: center;
    margin: 0 20px;
    border-radius: 5px;
    border: 1px solid #b4b2b2;
  }
  .business_container .options .business_option_view .price {
    color: #f52a4f;
    font-size: 36px;
    font-weight: 700;
    display: flex;
  }
  @media (max-width: 767px) {
    .business_container .options .business_option_view .price {
      text-align: center;
    }
  }
  .business_container .options .business_option_view .actions {
    margin-left: auto;
  }
  .business_container .options .business_option_view .actions button {
    margin: 0;
  }
  .business_container .listing-links li a.listing-links-fb {
    color: #fff;
    background: #3b5998;
  }
  .business_container .listing-links li a.listing-links-yt {
    color: #fff;
    background: #f00125;
  }
  .business_container .listing-links li a.listing-links-ig {
    color: #fff;
    background: #e1306c;
  }
  .business_container .listing-links li a.listing-links-tt {
    color: #fff;
    background: #1da1f2;
  }
  @media (max-width: 1366px) {
    #header_body,
    .business_container {
      margin: 0 5% !important;
    }
    #banners {
      margin: 65px 5% 0 !important;
    }
    .marketplace_landing_container #search_panel {
      width: 90%;
      left: 5%;
    }
    .form_preview .row {
      display: block;
    }
    .form_preview .row .col {
      margin-left: 0;
      margin-bottom: 20px;
    }
    #cabinet_body #pay_form .options_container,
    .form_preview .options_container {
      display: block;
    }
    #cabinet_body #pay_form .options_container .business_option,
    .form_preview .options_container .business_option {
      width: 100%;
      border-bottom: 1px solid grey;
      padding-bottom: 20px;
      margin-bottom: 20px;
    }
  }
  @media (max-width: 1024px) {
    .business_container .options .business_option_view .title {
      font-size: 20px;
    }
    .business_container p {
      font-size: 14px;
    }
  }
  @media screen and (max-width: 1024px) and (orientation: portrait) {
    .business_container .options .business_option_view .title {
      font-size: 18px;
      line-height: 20px;
    }
    .business_container p {
      font-size: 12px;
      line-height: 1.7;
    }
  }
  @media (max-width: 940px) {
    .marketplace_landing_container #search_panel {
      position: static;
      margin: 20px auto;
      display: block;
      height: auto;
      background-color: transparent;
      box-shadow: none;
      padding: 0;
    }
    .marketplace_landing_container #search_panel input,
    .marketplace_landing_container #search_panel select {
      height: 55px;
      line-height: 55px;
      border-radius: 4px;
      background: #fff;
      border: 1px solid #e0e0e0;
      box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.08);
      margin-bottom: 10px;
      padding: 0 10px;
    }
  }
  @media (max-width: 800px) {
    .business_container #left {
      padding-right: 0;
    }
    .business_container #right {
      margin-top: 20px;
    }
    .business_container #top {
      display: block;
    }
    #banners .business_banner {
      display: flex;
      flex-direction: column;
      border: 1px solid #efefef;
      width: 100%;
      height: auto;
    }
    #banners .image {
      height: auto;
    }
    #banners .image.wait_image_loader {
      width: 100%;
      height: 200px;
    }
    #banners .image img {
      width: 100%;
      height: auto;
    }
    #banners .info:before {
      background: none;
    }
    .marketplace_cabinet_container .menu:not(.visible) {
      left: -260px;
    }
    .marketplace_cabinet_container .menu:not(.visible) .mobile_menu_button {
      display: block;
    }
    .block_header {
      width: 85% !important;
      padding-left: 40px;
    }
    .block_header .customer,
    .block_header .debt {
      display: flex;
      flex-direction: column;
    }
    .block_header .customer span,
    .block_header .debt span {
      flex-direction: row;
    }
    .block_header .lib-btn.lib-btn-contract {
      display: none;
    }
    .marketplace_cabinet_container .menu.visible .hide_mobile_menu_button {
      display: block;
    }
    .marketplace_cabinet_container #cabinet_body {
      margin-left: 0;
    }
    .marketplace_cabinet_container #cabinet_body .form_header {
      width: 100%;
      padding-left: 60px;
    }
  }
  @media (max-width: 600px) {
    .business_container .options .business_option_view {
      display: block !important;
    }
    .business_container .options .business_option_view .actions,
    .business_container .options .business_option_view .title {
      text-align: center;
    }
    .business_container .options .business_option_view .image {
      margin-right: 0;
      margin-bottom: 30px;
    }
    #cabinet_body #customer_history .block_header {
      width: 100% !important;
      padding-left: 40px;
    }
    .win-base .business_ad_form .form_preview {
      min-width: 196px;
    }
    .win-base .bannersPositionsContainer {
      margin-right: 0;
      margin-left: 20px;
      width: 160px;
      min-width: 160px;
    }
    .win-base .bannersPositionsContainer .image {
      display: none;
    }
    .win-base .form_preview {
      padding: 20px 0 0;
    }
    .form_header h3 {
      display: none;
    }
    .business_container .options .business_option_view .quantity_input {
      margin: 0 8px;
    }
    #cabinet_body .new_loan_form .agent_container {
      display: block;
    }
    #cabinet_body .new_loan_form .agent_container input:first-child {
      width: 100%;
    }
    #cabinet_body .new_loan_form .agent_container input:last-child {
      margin-left: 0;
    }
  }
  .landing_container {
    display: block;
    overflow-x: hidden;
  }
  .landing_container .main-page {
    background: url(back_main_page.28ffa868.jpg) no-repeat;
    background-size: cover;
    background-position: 50%;
    height: 100%;
    min-height: 100%;
    color: #fff;
  }
  .landing_container .main-page .content-container {
    height: inherit;
    justify-content: space-around;
  }
  .landing_container .main-page h4 {
    font-weight: 400;
  }
  .landing_container .stake_info_container {
    color: #fff;
  }
  .landing_container .stake_info_container .stake_title {
    padding: 10px 0;
    border-bottom: 1px solid #fff;
    margin-top: 10px;
    text-align: center;
  }
  .landing_container .stake_info_container .stake_content {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
  .landing_container .stake_info_container .stake_content .stake_box {
    margin: 10px 0;
  }
  .landing_container .stake_info_container .stake_content h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 700;
  }
  .landing_container .stake_info_container .stake_content h5 {
    font-weight: 400;
    font-size: 12px;
    line-height: 150%;
  }
  .landing_container .back_container {
    background-size: cover;
    background-attachment: fixed;
  }
  .landing_container header {
    position: relative;
    height: unset;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .landing_container header .mob_nav_img img {
    width: 24px;
    height: 20px;
  }
  .landing_container .logo {
    width: 176px;
    height: 52px;
    background: url(microloan_logo.c074231d.png) no-repeat;
    background-size: 100% 100%;
  }
  .landing_container .title h2 {
    font-size: 28px;
    font-weight: 700;
    color: #595959;
    margin-bottom: 10px;
  }
  .landing_container p {
    font-size: 14px;
    color: #828282;
    line-height: 160%;
  }
  .right_panel {
    align-items: center;
  }
  .right_panel .icon-btn {
    margin-right: 10px;
  }
  .connection-icon-btn:hover {
    color: #d52927;
  }
  .eos_price_container {
    font-size: 12px;
    margin-right: 10px;
    width: 100px;
    text-align: center;
    background: #f52a4f;
    padding: 2px 0;
    box-shadow: 0 2px 6px -4px #000;
    display: flex;
    flex-direction: column;
  }
  .eos_price_container b {
    font-size: 20px;
  }
  .language_container {
    position: relative;
    width: 60px;
    height: 42px;
    text-align: center;
    transition: all 0.3s ease;
  }
  .language_container:hover .dropdown {
    display: flex;
  }
  .language_container .current_lang {
    cursor: pointer;
    height: 42px;
    font-size: 18px;
    line-height: 42px;
    color: #fff;
    font-weight: 700;
    border-bottom: 1px solid hsla(0, 0%, 100%, 0.9);
  }
  .language_container .dropdown {
    position: absolute;
    top: 42px;
    width: 60px;
    left: 0;
    display: none;
    flex-direction: column;
    justify-content: center;
    color: #fff;
  }
  .language_container .dropdown div {
    cursor: pointer;
    padding: 4px 0;
  }
  .language_container .dropdown div:hover {
    color: #d52927;
  }
  .btn_type_2 button.lib-btn.lib-btn-contract {
    background: linear-gradient(90deg, #f91942 30%, #f0cb35 130%);
    border: none;
    color: #fff;
    font-weight: 700;
    margin: 0 auto;
    padding: 14px 24px;
    transition: all 0.5s ease;
  }
  .btn_type_2 button.lib-btn.lib-btn-contract:hover {
    background: linear-gradient(120deg, #f91942 30%, #f0cb35 130%);
  }
  button.lib-btn {
    margin-right: 10px;
    font-size: 18px;
    font-weight: 700;
    margin-bottom: 10px;
  }
  .subscribe-btn {
    background: none;
    color: #fff;
    font-size: 14px;
    padding: 6px 24px;
    border: 1px solid #fff;
    border-radius: 8px;
  }
  .button_container {
    margin-top: 20px;
  }
  .button_container,
  footer {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  footer {
    justify-content: center;
    height: 200px;
    background: #353535;
    text-align: center;
    color: #fff;
  }
  footer .build_eos {
    margin-bottom: 10px;
    align-items: center;
  }
  footer .build_eos p {
    color: #fff;
  }
  footer .build_eos img {
    width: 20px;
    margin-bottom: 10px;
  }
  .more_info_about_microloan.auth-page_header header {
    background: none;
    box-shadow: none;
  }
  .more_info_about_microloan {
    padding-bottom: 50px;
    padding-top: 100px;
  }
  .more_info_about_microloan .content-container.header_container {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: auto;
    justify-content: space-between;
  }
  .more_info_about_microloan .open_nav {
    display: flex !important;
  }
  .more_info_about_microloan nav {
    display: none;
    flex-direction: column;
    align-items: flex-end;
    position: absolute;
    top: 70px;
    background: #252525;
    width: 100%;
    left: 0;
  }
  .more_info_about_microloan nav .link {
    margin: 10px 0;
    color: #fff;
    font-weight: 700;
    cursor: pointer;
  }
  .more_info_about_microloan nav .link:hover {
    text-decoration: underline;
    color: #e39d33;
  }
  .more_info_about_microloan nav .language_container {
    margin: 10px 0;
  }
  .more_info_about_microloan nav .current_lang {
    border: none;
  }
  .more_info_about_microloan nav .dropdown {
    background: #e09232;
    box-shadow: 0 4px 3px -1px rgba(0, 0, 0, 0.28);
  }
  .more_info_about_microloan header {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: linear-gradient(90deg, #f91942 30%, #f0cb35 130%);
    height: 70px;
    text-align: center;
    margin-bottom: 40px;
    box-shadow: 0 0 5px -1px #000;
  }
  .more_info_about_microloan h2 {
    font-size: 36px;
    font-weight: 700;
    color: #595959;
  }
  .more_info_about_microloan h3 {
    color: #595959;
    font-size: 20px;
    font-weight: 500;
  }
  .more_info_about_microloan p {
    font-size: 14px;
    line-height: 160%;
    font-weight: 500;
    color: #828282;
    margin-bottom: 20px;
  }
  .content-container {
    margin: 0 10px;
  }
  @media screen and (max-width: 900px) and (orientation: portrait) {
    .content-container h1 {
      font-size: 7.5vw;
    }
  }
  @media screen and (max-width: 900px) and (orientation: landscape) {
    .content-container h1 {
      font-size: 2rem;
    }
  }
  @media (min-width: 1280px) {
    .content-container {
      width: 1170px;
      margin: 0 auto;
    }
    .content-container h1 {
      font-size: 2.8rem;
    }
    .content-container h3 {
      font-size: 1.4rem;
    }
    .content-container header .logo {
      width: 328px;
      height: 96px;
    }
    .content-container .subscribe-btn,
    .content-container button.lib-btn {
      font-size: 22px;
      padding: 14px 30px;
    }
    .content-container button.subscribe-btn.lib-btn {
      font-size: 20px;
    }
    .content-container .button_container {
      margin-top: 40px;
    }
  }
  .terms_of_use_content h2 {
    text-align: center;
  }
  .terms_of_use_content p {
    margin-bottom: 10px;
  }
  .terms_of_use_content hr {
    margin: 10px 0;
  }
  .terms_of_use_content .button_container {
    text-align: center;
  }
  .terms_of_use_content .button_container button {
    margin-top: 10px;
  }
  .connection_window_content {
    width: 500px;
  }
  .connection_window_content .header {
    justify-content: center;
  }
  .connection_window_content h2 {
    margin: 0 0 10px;
    display: flex;
    align-items: center;
  }
  .connection_window_content h2 i {
    margin-left: 10px;
  }
  .connection_window_content hr {
    margin: 20px 0;
  }
  .connection_window_content .free_cpu_block {
    display: flex;
  }
  .connection_window_content .free_cpu_block label {
    cursor: pointer;
    display: flex;
  }
  .connection_window_content .free_cpu_block label input {
    margin-left: 10px;
  }
  .connection_window_content .node_block {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    border: 1px solid #c3c3c3;
    margin-bottom: 10px;
    align-items: center;
    box-shadow: 0 0 5px -3px #000;
  }
  .connection_window_content .node_block .name {
    font-weight: 700;
    font-size: 18px;
  }
  .connection_window_content .node_block .url {
    color: grey;
    font-size: 14px;
  }
  .connection_window_content .node_block .latency {
    font-size: 12px;
  }
  .connection_window_content .node_block .actions {
    display: flex;
    align-items: end;
    flex-direction: column;
  }
  .connection_window_content .node_block .actions button {
    margin: 2px;
  }
  .connection_window_content .custom_node_input_parent {
    width: 100%;
  }
  .connection_window_content .custom_node_input_parent input {
    width: 100%;
    padding: 6px;
    border: none;
    font-size: 14px;
  }
  @media (max-width: 1024px) {
    .content-container.header_container {
      width: 100%;
    }
  }
  @media (min-width: 1024px) {
    .content-container.header_container {
      width: 1170px;
    }
    .mob_nav_img {
      display: none;
    }
    .more_info_about_microloan nav {
      position: relative;
      top: 0;
      display: flex;
      background: none;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
    }
    .more_info_about_microloan nav .link {
      margin: 0 10px;
    }
    .more_info_about_microloan nav .link:hover {
      color: #fff;
    }
    .subscribe-btn {
      font-size: 18px;
    }
    .button_container {
      flex-direction: row;
    }
    .landing_container .stake_info_container .stake_title {
      text-align: left;
    }
    .landing_container .logo {
      width: 230px;
    }
    .landing_container button.lib-btn {
      margin-bottom: 0;
    }
    .landing_container .title h2 {
      font-size: 36px;
    }
    .landing_container p,
    .more_info_about_microloan p {
      font-size: 16px;
      line-height: 218%;
    }
    .more_info_about_microloan h3 {
      font-size: 24px;
    }
  }
  @media (max-width: 900px) {
    .content-container.header_container {
      width: 100%;
    }
  }
  @media screen and (max-width: 900px) and (orientation: landscape) {
    .landing_container .main-page {
      height: auto;
      min-height: auto;
    }
  }
  @media (min-width: 1280px) {
    .landing_container h4 {
      font-size: 18px;
    }
    .landing_container .button_container,
    .landing_container .stake_info_container .stake_content {
      flex-direction: row;
    }
    .stake_info_container .stake_content {
      width: 100%;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }
    .stake_info_container .stake_content .stake_box {
      padding: 5px 0;
      width: 300px;
    }
    .stake_info_container .stake_content .stake_box h3 {
      font-size: 24px;
    }
    .stake_info_container .stake_content .stake_box h5 {
      font-size: 14px;
    }
    .stake_info_container .stake_content .stake_box:first-child,
    .stake_info_container .stake_content .stake_box:nth-child(2),
    .stake_info_container .stake_content .stake_box:nth-child(3) {
      margin-right: auto;
    }
    .stake_info_container .stake_content .stake_box:first-child {
      text-align: left;
    }
    .stake_info_container .stake_content .stake_box:nth-child(4) {
      text-align: right;
    }
  }
  @media (max-width: 320px) {
    .landing_container .logo {
      width: 120px;
      height: 36px;
    }
  }
  .b2c_container {
    background: url(b2c_back.ffff8ce9.jpg) no-repeat;
    background-position: 100%;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 30px 0;
  }
  .b2c_container .content-container {
    height: inherit;
    min-height: inherit;
  }
  .about_project {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-content: space-around;
  }
  .about_project .a_title {
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    color: #595959;
    margin-bottom: 20px;
  }
  .about_project .a_box {
    align-items: center;
    margin: 30px 0;
  }
  .about_project .a_box img {
    width: 52px;
    height: 52px;
    margin: 10px;
  }
  .about_project .a_box h3 {
    font-weight: 700;
    color: #595959;
  }
  .about_project .a_box p {
    color: #828282;
  }
  .about_project .img_app {
    margin: 0 auto;
    width: 300px;
  }
  .about_project .img_app img {
    margin: 10px auto;
    width: inherit;
  }
  .about_project .btn_type_2 {
    text-align: center;
    margin: 20px 0 50px;
  }
  @media (min-width: 1024px) {
    .b2c_container {
      background-position: 50%;
      min-height: 50%;
    }
    .b2c_container p {
      line-height: 118%;
    }
    .a_business .a_box img {
      margin: 10px 0 10px 10px;
    }
    .a_client .a_box img {
      margin: 10px 10px 10px 0;
    }
    .about_project .img_app {
      width: 440px;
    }
    .about_project {
      flex-direction: row;
    }
    .about_project .a_title {
      text-align: left;
    }
    .about_project .revers_title {
      text-align: right;
    }
    .about_project .revers_box {
      flex-direction: row-reverse;
    }
    .about_project .revers_box .a_desc {
      text-align: right;
    }
    .about_project .img_app img {
      width: 200px;
    }
  }
  @media (min-width: 1280px) {
    .b2c_container {
      padding: 0;
      min-height: 100%;
    }
    .img_app img {
      width: 234px;
    }
  }
  .about_project_type_2 {
    background: url(back_about_project_type_2.c796dd4e.jpg) no-repeat;
    background-position: 0;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 30px 0;
  }
  .about_project_type_2 img,
  .about_project_type_2 p {
    width: 100%;
    margin: 20px 0;
  }
  .about_project_type_2 .lib-rev-hbox {
    width: 100%;
    flex-flow: column-reverse;
  }
  @media (min-width: 1024px) {
    .about_project_type_2 {
      min-height: auto;
      background-position: 50%;
    }
    .about_project_type_2 .lib-rev-hbox {
      flex-flow: row;
      align-items: center;
      justify-content: center;
    }
    .about_project_type_2 img,
    .about_project_type_2 p {
      width: 50%;
    }
  }
  @media (min-width: 1280px) {
    .about_project_type_2 {
      min-height: 100%;
    }
  }
  .back_why_microloan {
    background: url(back_why_microloan.440a466b.jpg) no-repeat;
    background-position: 0;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 30px 0;
    text-align: center;
  }
  .back_why_microloan .title {
    margin-bottom: 30px;
  }
  .back_why_microloan h4 {
    font-size: 18px;
    font-weight: 500;
    color: #828282;
  }
  .back_why_microloan p {
    margin-bottom: 20px;
    text-align: justify;
  }
  .back_why_microloan .read_more_btn {
    text-align: center;
    color: #595959;
  }
  @media (min-width: 1024px) {
    .back_why_microloan {
      min-height: unset;
    }
    .back_why_microloan .read_more_btn {
      text-align: right;
      text-decoration: underline;
      font-weight: 700;
    }
  }
  @media (min-width: 1280px) {
    .back_why_microloan {
      min-height: 100%;
    }
    .back_why_microloan h2 {
      font-size: 36px;
    }
  }
  .mtl_token {
    justify-content: center;
    align-items: center;
    margin-top: 40px;
  }
  .mtl_token .box.back_supply {
    background: url(back_supply.5052da1e.jpg) no-repeat;
    background-size: 100%;
    background-position: 50%;
  }
  .mtl_token .box.back_rate {
    background: url(back_rate.c10c5458.jpg) no-repeat;
    background-size: 100%;
    background-position: 50%;
  }
  .mtl_token .box {
    width: 320px;
    height: 126px;
    color: #fff;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    margin: 20px;
  }
  .mtl_token .box h4 {
    font-size: 18px;
    font-weight: 500;
  }
  .mtl_token .box h3 {
    font-size: 24px;
    font-weight: 700;
  }
  @media (min-width: 1024px) {
    .mtl_token {
      margin-top: 0;
      height: 438px;
    }
    .mtl_token .lib-vbox {
      flex-flow: row nowrap;
      justify-content: center;
      margin-top: 20px;
    }
  }
  .stake_container {
    background: url(back_stake.29d8f2b3.jpg) no-repeat;
    background-position: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 30px 0;
  }
  .stake_container .stake_info_container {
    color: #595959;
  }
  .stake_container .stake_info_container .stake_title {
    border-color: #595959;
  }
  .stake_container h4 {
    font-size: 24px;
    color: #595959;
    font-weight: 700;
    margin-bottom: 30px;
    text-align: center;
  }
  .stake_container .desc {
    width: 100%;
  }
  .stake_container img {
    width: 100%;
    margin: 20px 0;
  }
  @media (min-width: 1024px) {
    .stake_container .stake_info_container .stake_content {
      flex-flow: row;
      justify-content: space-around;
    }
    .stake_container h4 {
      text-align: left;
    }
    .stake_container .desc {
      width: 55%;
    }
    .stake_container .lib-vbox {
      flex-flow: row;
      align-items: center;
    }
    .stake_container img {
      width: 40%;
    }
  }
  .quote_content {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    height: 340px;
    color: #595959;
    font-weight: 700;
    padding: 20px 0;
    line-height: 184%;
    text-align: center;
  }
  .quote_content .decor {
    position: relative;
  }
  .quote_content .decor:before {
    position: absolute;
    content: "";
    top: 0;
    left: 30px;
    width: 108px;
    height: 86px;
    background: url(decor_for_quote.e0cf5280.png) no-repeat;
    background-size: 100% 100%;
    background-position: 50%;
    transform: translate(-50%, -50%);
  }
  .quote_content .btn_type_2 {
    margin: 10px 0;
  }
  @media (min-width: 1024px) {
    .quote_content {
      width: 820px;
      font-size: 18px;
      margin: 0 auto;
      height: 440px;
    }
  }
  @media (min-width: 1280px) {
    .quote_content {
      width: 985px;
      text-align: center;
      font-weight: 700;
      font-size: 24px;
      margin: 0 auto;
      line-height: 186%;
    }
    .quote_content .decor:before {
      width: 188px;
      height: 166px;
      left: 0;
      top: 30%;
    }
    .quote_content .btn_type_2 {
      align-self: flex-end;
    }
  }
  .stage-popup {
    position: fixed;
    z-index: 21;
    padding: 12px 16px 12px 44px;
    bottom: 52px;
    left: 50%;
    max-width: 800px;
    width: 100%;
    min-width: 300px;
    transform: translateX(-50%);
    display: flex;
    color: #fefefe;
    font-size: 15px;
    opacity: 1;
    box-sizing: border-box;
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
    border: 1px solid #2c2c2c;
    border-radius: 4px;
    animation: stagePopupAnim 0.1s linear;
  }
  .stage-popup-error {
    background-color: #88403b;
  }
  .stage-popup-info {
    background-color: #2c8020;
  }
  .stage-popup-error:before,
  .stage-popup-info:before {
    content: "";
    display: block;
    position: absolute;
    background-size: 28px 28px;
    width: 28px;
    height: 28px;
    left: 8px;
    top: 8px;
  }
  .stage-popup-error:before {
    background-image: url(popup_error_icon.ff603857.png);
  }
  .stage-popup-info:before {
    background-image: url(popup_success_icon.80bb4193.png);
  }
  .stage-popup-hide {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.1s ease-in, visibility 0.1s;
  }
  @keyframes stagePopupAnim {
    0% {
      opacity: 0;
      top: 6px;
    }
  }
  #ual-button {
    font-family: Proxima Nova, sans-serif;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    font-size: 1em;
    font-weight: 700;
    background-color: #193270;
    cursor: pointer;
    width: 225px !important;
    padding: 10px 0;
    position: relative;
  }
  #ual-button:before {
    position: absolute;
    content: "Login with Wallet";
    background: linear-gradient(-180deg, #f52a4f, #33001b);
    width: 100%;
    left: 0;
    top: 0;
    border-radius: 5px;
    padding: 10px 0;
  }
  .connection_error_page_container {
    text-align: center;
  }

  .marketplace_landing_container {
    /* width: 95vw; */
  }
  #banners,
  .banners {
    text-align: left;
  }
</style>
